"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable camelcase, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, no-underscore-dangle */
/* eslint-disable max-len, react/no-array-index-key */
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var const_1 = require("@src/containers/CodeNode/utils/const");
var BotActions_1 = require("@src/actions/BotActions");
var History_1 = __importDefault(require("@src/History"));
var _utils_1 = require("@src/actions/_utils");
var const_2 = require("@src/const");
var CodeEditor_1 = __importDefault(require("@src/components/CodeEditor"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
// SVG so svg-react-loader compiles each icon into a React component, the way
// every other icon in this app is delivered. They then travel inside the JS
// bundle rather than as separate files the web server has to serve.
var bot_response_svg_1 = __importDefault(require("../assets/workflow/bot-response.svg"));
var condition_svg_1 = __importDefault(require("../assets/workflow/condition.svg"));
var drag_handle_svg_1 = __importDefault(require("../assets/workflow/drag-handle.svg"));
var intent_detection_svg_1 = __importDefault(require("../assets/workflow/intent-detection.svg"));
var parameter_collection_svg_1 = __importDefault(require("../assets/workflow/parameter-collection.svg"));
var tool_execution_svg_1 = __importDefault(require("../assets/workflow/tool-execution.svg"));
// The same tool vocabulary the agents page uses, so a workflow tool is
// configured and seeded exactly like an agent tool.
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var actions_1 = require("../../CodeNode/store/actions");
var utils_1 = require("../utils");
var selectors_1 = require("../store/selectors");
var actions_2 = require("../store/actions");
var api_1 = require("../store/api");
var NODE_WIDTH = 270;
var NODE_HEIGHT = 94;
var MIN_ZOOM = 0.25;
var MAX_ZOOM = 3;
var MIN_CANVAS_WIDTH = 3200;
var MIN_CANVAS_HEIGHT = 2200;
var CANVAS_MARGIN = 600;
var EDITOR_PANEL_WIDTH = 590;
// The step editor keeps at least this much height and this gap from the
// canvas edges, so its Save Step / Delete footer always stays on screen.
var EDITOR_MIN_HEIGHT = 320;
var EDITOR_EDGE_GAP = 12;
// Pointer travel before a press on the canvas counts as a pan, not a click.
var PAN_THRESHOLD_PX = 4;
// The palette floats above the canvas rather than reserving layout space, so
// these are only used to keep things the user focuses on out from under it.
var PALETTE_OVERLAY_WIDTH = 340;
var PALETTE_CLEARANCE = 332;
var APP_HEADER_HEIGHT = 64;
// Scrollable canvas before the first step. Without it scrollLeft bottoms out at
// 0 and a step near the origin can never be brought to the middle - it just sits
// under the floating palette. This is canvas to scroll through, not page padding.
var CANVAS_GUTTER_X = 1200;
var CANVAS_GUTTER_Y = 600;
// Steps can sit anywhere, left of or above 0 too. The canvas origin follows
// the left-most / top-most step, moved in steps of this size so it does not
// shift on every pixel of a drag.
var GRAPH_ORIGIN_STEP = 400;
var FOCUS_HIGHLIGHT_MS = 1600;
// "Saved" only needs a glance; failures and warnings stay longer so they can
// be read. Any message can also be closed straight away.
var SUCCESS_TOAST_MS = 1800;
var NOTICE_TOAST_MS = 6000;
// The builder's own messages sit along the bottom of the canvas, clear of the
// palette on the left, and never cover or block the rest of the builder.
var TOAST_TONES = {
    success: { border: '#12b76a', role: 'status' },
    warning: { border: '#f79009', role: 'status' },
    error: { border: '#f04438', role: 'alert' },
};
var editorCardStyle = {
    margin: '10px 0',
    padding: 12,
    border: '1px solid #e3e7ef',
    borderLeft: '3px solid #146ef5',
    borderRadius: 9,
    background: '#fcfcfd',
};
var audioIconButtonStyle = {
    width: 36,
    height: 36,
    display: 'grid',
    placeItems: 'center',
    padding: 0,
    border: '1px solid #d8dee8',
    borderRadius: 8,
    color: '#146ef5',
    background: '#fff',
    cursor: 'pointer',
};
// Disabled audio buttons are greyed out; inline styles would otherwise keep
// them looking clickable.
var audioIconButtonDisabledStyle = {
    color: '#98a2b3',
    background: '#f2f4f7',
    cursor: 'not-allowed',
};
var NODE_TYPES = [
    { id: 'bot_response', name: 'Bot Response', color: '#11b8bd' },
    {
        id: 'intent_detection',
        name: 'Intent Detection',
        color: '#f2b51d',
    },
    {
        id: 'capture_parameter',
        name: 'Parameter Collection',
        color: '#7657e8',
    },
    { id: 'condition', name: 'Condition', color: '#1670ee' },
    {
        id: 'tool_execution',
        name: 'Tool Execution',
        color: '#ff7a14',
    },
    {
        id: 'fallback_node',
        name: 'Default Fallback',
        color: '#ef4444',
    },
];
var WorkflowNodeIcon = function (_a) {
    var type = _a.type;
    var Icon = {
        bot_response: bot_response_svg_1["default"],
        intent_detection: intent_detection_svg_1["default"],
        capture_parameter: parameter_collection_svg_1["default"],
        condition: condition_svg_1["default"],
        tool_execution: tool_execution_svg_1["default"],
    }[type];
    if (Icon) {
        return (react_1["default"].createElement(Icon, { "aria-hidden": "true", focusable: "false", draggable: false, style: {
                display: 'block',
                width: '100%',
                height: '100%',
            } }));
    }
    // Every type without a bundled icon (currently fallback_node) shares this mark.
    return (react_1["default"].createElement("svg", { width: 23, height: 23, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
        react_1["default"].createElement("circle", { cx: "12", cy: "12", r: "8", stroke: "currentColor", strokeWidth: "2" }),
        react_1["default"].createElement("circle", { cx: "12", cy: "12", r: "3", stroke: "currentColor", strokeWidth: "2" }),
        react_1["default"].createElement("path", { d: "m6.3 6.3 3.6 3.6m4.2 4.2 3.6 3.6m0-11.4-3.6 3.6m-4.2 4.2-3.6 3.6", stroke: "currentColor", strokeWidth: "1.7" })));
};
var titleFor = function (type) { var _a; return ((_a = NODE_TYPES.find(function (item) { return item.id === type; })) === null || _a === void 0 ? void 0 : _a.name) || type; };
var OPERATOR_LABELS = {
    equals: '=',
    not_equals: '≠',
    greater_than: '>',
    greater_than_or_equal: '≥',
    less_than: '<',
    less_than_or_equal: '≤',
    contains: 'contains',
    not_contains: 'does not contain',
    exists: 'exists',
    not_exists: 'does not exist',
};
var describeCondition = function (condition) {
    var _a;
    var parameter = String((condition === null || condition === void 0 ? void 0 : condition.parameter) || '').trim() || '?';
    var operator = OPERATOR_LABELS[condition === null || condition === void 0 ? void 0 : condition.operator] || (condition === null || condition === void 0 ? void 0 : condition.operator);
    return ['exists', 'not_exists'].includes(condition === null || condition === void 0 ? void 0 : condition.operator)
        ? parameter + " " + operator
        : (parameter + " " + operator + " " + ((_a = condition === null || condition === void 0 ? void 0 : condition.value) !== null && _a !== void 0 ? _a : '')).trim();
};
// The card preview reads back what the step actually holds; a placeholder only
// appears when the step genuinely has nothing configured yet.
var summaryFor = function (node, tools, primaryLanguage) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (tools === void 0) { tools = []; }
    if (primaryLanguage === void 0) { primaryLanguage = 'en'; }
    if (node.type === 'bot_response') {
        var responses = node.responses || [];
        var primary = responses.find(function (response) { return response.language_code === primaryLanguage; }) || responses[0];
        return String((primary === null || primary === void 0 ? void 0 : primary.response) || '').trim() || 'No response written yet';
    }
    if (node.type === 'intent_detection') {
        var intents = (((_a = node.config) === null || _a === void 0 ? void 0 : _a.intents) || [])
            .map(function (intent) { return String((intent === null || intent === void 0 ? void 0 : intent.name) || '').trim(); })
            .filter(Boolean);
        return intents.length ? intents.join(' · ') : 'No intents added yet';
    }
    if (node.type === 'capture_parameter') {
        var parameters = (((_b = node.config) === null || _b === void 0 ? void 0 : _b.parameters) || [])
            .map(function (parameter) {
            var name = String((parameter === null || parameter === void 0 ? void 0 : parameter.name) || '').trim();
            return name && (parameter === null || parameter === void 0 ? void 0 : parameter.required) ? name + "*" : name;
        })
            .filter(Boolean);
        return parameters.length
            ? parameters.join(' · ')
            : 'No parameters added yet';
    }
    if (node.type === 'condition') {
        var conditions = (((_c = node.config) === null || _c === void 0 ? void 0 : _c.conditions) || []).map(describeCondition);
        if (!conditions.length)
            return 'No conditions added yet';
        var joiner = ((_d = node.config) === null || _d === void 0 ? void 0 : _d.match) === 'any' ? ' OR ' : ' AND ';
        return conditions.join(joiner);
    }
    var linkedTool = tools.find(function (tool) { return String(tool.id) === String(node.tool_id); });
    var name = ((_e = node.tool_definition) === null || _e === void 0 ? void 0 : _e.name) || (linkedTool === null || linkedTool === void 0 ? void 0 : linkedTool.name);
    if (!name)
        return 'No tool selected yet';
    var mode = ((_f = node.tool_definition) === null || _f === void 0 ? void 0 : _f.mode) || (linkedTool === null || linkedTool === void 0 ? void 0 : linkedTool.mode);
    var target = ((_g = node.tool_definition) === null || _g === void 0 ? void 0 : _g.target_agent) || (linkedTool === null || linkedTool === void 0 ? void 0 : linkedTool.target_agent);
    if (mode === 'handoff') {
        return target ? "Hand off to " + target : name + " \u00B7 handoff";
    }
    return mode ? name + " \u00B7 " + mode : name;
};
// Draft ids only need to be unique within one builder session; Date.now()
// alone collides when two steps are added inside the same millisecond.
var draftSequence = 0;
var nextDraftId = function () {
    draftSequence += 1;
    return "draft-" + Date.now() + "-" + draftSequence;
};
var uniqueNodeName = function (type, existing) {
    var base = titleFor(type) + " Step";
    var taken = new Set(existing.map(function (node) {
        return String(node.node_name || '')
            .trim()
            .toLowerCase();
    }));
    if (!taken.has(base.toLowerCase()))
        return base;
    var suffix = 2;
    while (taken.has((base + " " + suffix).toLowerCase()))
        suffix += 1;
    return base + " " + suffix;
};
var newNode = function (type, index, existing, defaultLanguage, defaultAiModel, defaultIntentModel) {
    if (existing === void 0) { existing = []; }
    if (defaultLanguage === void 0) { defaultLanguage = 'en'; }
    if (defaultAiModel === void 0) { defaultAiModel = {
        provider: '',
        model: '',
    }; }
    if (defaultIntentModel === void 0) { defaultIntentModel = {
        provider: '',
        model: '',
    }; }
    return ({
        id: nextDraftId(),
        type: type,
        node_name: uniqueNodeName(type, existing),
        is_entry: false,
        // Start clear of the floating palette, which now overlays the canvas.
        position_x: PALETTE_OVERLAY_WIDTH + 40 + (index % 4) * 330,
        position_y: 100 + Math.floor(index / 4) * 180,
        metadata: {},
        config: type === 'intent_detection'
            ? {
                intent_model: __assign({}, defaultIntentModel),
                conversation_context: 4,
                date_time_context_enabled: false,
                intents: [
                    {
                        name: 'Yes',
                        description: 'The customer confirms.',
                        keywords: ['yes'],
                    },
                    {
                        name: 'No',
                        description: 'The customer declines.',
                        keywords: ['no'],
                    },
                ],
            }
            : type === 'capture_parameter'
                ? {
                    ai_model: __assign({}, defaultAiModel),
                    conversation_context: 2,
                    date_time_context_enabled: false,
                    parameters: [
                        {
                            name: 'customer_name',
                            type: 'string',
                            description: 'Customer name.',
                            required: false,
                        },
                    ],
                }
                : type === 'condition'
                    ? {
                        match: 'all',
                        conditions: [{ parameter: 'customer_name', operator: 'exists' }],
                    }
                    : ['tool_execution', 'fallback_node'].includes(type)
                        ? { acknowledgement_config: { type: 'nothing', response_node_id: null } }
                        : { user_pause_duration: { enabled: false, seconds: 0.3 } },
        destinations: [],
        responses: type === 'bot_response'
            ? [
                {
                    language_code: defaultLanguage,
                    response: 'Hello! How can I assist you today?',
                    response_url: null,
                },
            ]
            : [],
        tool_id: null,
        tool_source: ['tool_execution', 'fallback_node'].includes(type)
            ? 'common'
            : null,
        tool_definition: null,
        _draft: true,
    });
};
var cleanNode = function (node) { return (__assign(__assign({}, (!node._draft ? { id: node.id } : {})), { type: node.type, node_name: node.node_name, is_entry: Boolean(node.is_entry), position_x: Number(node.position_x || 0), position_y: Number(node.position_y || 0), metadata: node.metadata || {}, config: (function () {
        var config = __assign({}, (node.config || {}));
        // A newly selected intent model supersedes the legacy ai_model field.
        // Existing nodes without intent_model retain ai_model unchanged.
        if (node.type === 'intent_detection' && config.intent_model) {
            delete config.ai_model;
        }
        return config;
    })(), destinations: node.destinations || [], responses: (node.responses || []).map(function (response) { return (__assign(__assign({}, (response.id ? { id: response.id } : {})), { language_code: response.language_code, response: response.response, response_url: response.response_url || null })); }), tool_id: node.tool_id || null, tool_source: ['tool_execution', 'fallback_node'].includes(node.type)
        ? node.tool_source || 'common'
        : null, tool_definition: ['tool_execution', 'fallback_node'].includes(node.type) &&
        node.tool_source === 'agent_specific'
        ? node.tool_definition || null
        : null })); };
// When no step is marked as the entry, the backend starts the call at the saved
// step with the lowest id. Drafts have no id yet, so they can never be it.
var implicitStartNodeFor = function (nodes) {
    if (nodes.some(function (node) { return node.is_entry; }))
        return null;
    var lowestOf = function (candidates) {
        return candidates.reduce(function (lowest, node) {
            return !lowest || Number(node.id) < Number(lowest.id) ? node : lowest;
        }, null);
    };
    var saved = nodes.filter(function (node) { return !node._draft && Number.isFinite(Number(node.id)); });
    // Same rule as the backend: the Fallback step is skipped, because starting
    // there would hand every call off. It is used only if nothing else exists.
    return (lowestOf(saved.filter(function (node) { return node.type !== 'fallback_node'; })) ||
        lowestOf(saved));
};
var withPersistedSnapshot = function (node) {
    var persisted = JSON.parse(JSON.stringify(node));
    delete persisted._persisted;
    delete persisted._draft;
    return __assign(__assign({}, node), { _draft: false, _persisted: persisted });
};
// contakt_workflow_nodes.node_name is String(200); anything longer is a 422.
var NODE_NAME_MAX_LENGTH = 200;
// The response column is TEXT with no upper bound, but a spoken reply longer
// than this is far too long for a call, so the editor refuses to save one.
var RESPONSE_MAX_LENGTH = 1000;
var RESPONSE_TOO_LONG = "Responses can be at most " + RESPONSE_MAX_LENGTH + " characters.";
// Parameter names are referenced from Conditions and as {name} placeholders in
// Bot Responses, which only recognise identifier-style names.
var PARAMETER_NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
var PARAMETER_NAME_HINT = "Use only letters, numbers and underscores; don't start with a number.";
// An empty name is reported separately (or allowed, for optional fields), so
// only a non-empty name that breaks the pattern counts as malformed.
var parameterNameError = function (value) {
    var name = String(value !== null && value !== void 0 ? value : '').trim();
    return name && !PARAMETER_NAME_PATTERN.test(name)
        ? PARAMETER_NAME_HINT
        : null;
};
var LIVE_TTS_HINT = "This voice is spoken live during the call, so a preview isn't available.";
var CUSTOM_ACK_MISSING = 'Choose a Bot Response step for the custom message.';
// A connection's shape is remembered on the source node's free-form metadata,
// keyed by the same route key the destination uses.
var routeActionFor = function (node) {
    var _a, _b, _c;
    return ((_b = (_a = node.destinations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.on_action) || ((_c = node.metadata) === null || _c === void 0 ? void 0 : _c.route_action) ||
        'user_reply';
};
var edgePointFor = function (node, key) { var _a, _b; return ((_b = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.edge_points) === null || _b === void 0 ? void 0 : _b[key]) || null; };
var withEdgePoint = function (node, key, point) {
    var _a;
    var points = __assign({}, (((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.edge_points) || {}));
    if (point)
        points[key] = point;
    else
        delete points[key];
    var metadata = __assign({}, (node.metadata || {}));
    if (Object.keys(points).length)
        metadata.edge_points = points;
    else
        delete metadata.edge_points;
    return __assign(__assign({}, node), { metadata: metadata });
};
var edgePath = function (x1, y1, x2, y2, point) {
    if (!point) {
        var bend = Math.max(70, Math.abs(x2 - x1) / 2);
        return "M " + x1 + " " + y1 + " C " + (x1 + bend) + " " + y1 + ", " + (x2 - bend) + " " + y2 + ", " + x2 + " " + y2;
    }
    // Two cubics meeting at the waypoint, so the line actually passes through
    // where it was dropped rather than merely leaning towards it.
    var inBend = Math.max(40, Math.abs(point.x - x1) / 2);
    var outBend = Math.max(40, Math.abs(x2 - point.x) / 2);
    return [
        "M " + x1 + " " + y1,
        "C " + (x1 + inBend) + " " + y1 + ", " + (point.x - inBend) + " " + point.y + ", " + point.x + " " + point.y,
        "C " + (point.x + outBend) + " " + point.y + ", " + (x2 - outBend) + " " + y2 + ", " + x2 + " " + y2,
    ].join(' ');
};
// Quick and Advanced differ only in which template they start from and
// whether a code-executor function backs them; the runtime accepts both
// through the same shared executor.
var codeTemplateFor = function (codeType) {
    return codeType === 'quick'
        ? VoiceAgentLayoutUtils_1.QUICK_CODE_MULTI_VOICE_AGENT
        : const_1.INIT_CODE_MULTI_VOICE_AGENT;
};
// The rules the backend enforces that the editor can check first, so a save
// fails with the offending name rather than a positional server error.
var firstDuplicate = function (names) {
    var seen = new Set();
    return names.find(function (name) {
        var key = name.trim().toLowerCase();
        if (!key)
            return false;
        if (seen.has(key))
            return true;
        seen.add(key);
        return false;
    });
};
var nodeIssue = function (node, isSupportedLanguage) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (isSupportedLanguage === void 0) { isSupportedLanguage = function () { return true; }; }
    if (node.type === 'bot_response') {
        var allResponses = node.responses || [];
        if (!allResponses.length) {
            return 'Add at least one language response before saving.';
        }
        // Variations in a language the bot no longer supports are read-only and
        // never spoken, so they cannot be fixed and must not block a save.
        var responses = allResponses.filter(function (response) {
            return isSupportedLanguage((response === null || response === void 0 ? void 0 : response.language_code) || 'en');
        });
        var blank = responses.findIndex(function (response) { return !String((response === null || response === void 0 ? void 0 : response.response) || '').trim(); });
        if (blank !== -1) {
            var language = ((_a = responses[blank]) === null || _a === void 0 ? void 0 : _a.language_code) || '';
            return "The" + (language ? " " + language : '') + " response has no text.";
        }
        var tooLong = responses.find(function (response) {
            return String((response === null || response === void 0 ? void 0 : response.response) || '').length > RESPONSE_MAX_LENGTH;
        });
        if (tooLong) {
            var language = tooLong.language_code || '';
            return "The" + (language ? " " + language : '') + " response is too long. " + RESPONSE_TOO_LONG;
        }
    }
    if (node.type === 'intent_detection') {
        var duplicate = firstDuplicate((((_b = node.config) === null || _b === void 0 ? void 0 : _b.intents) || []).map(function (intent) { return String((intent === null || intent === void 0 ? void 0 : intent.name) || ''); }));
        if (duplicate)
            return "More than one intent is named \u201C" + duplicate + "\u201D.";
    }
    if (node.type === 'capture_parameter') {
        var parameters = ((_c = node.config) === null || _c === void 0 ? void 0 : _c.parameters) || [];
        var duplicate = firstDuplicate(parameters.map(function (parameter) { return String((parameter === null || parameter === void 0 ? void 0 : parameter.name) || ''); }));
        if (duplicate)
            return "More than one parameter is named \u201C" + duplicate + "\u201D.";
        var unnamed = parameters.findIndex(function (parameter) { return !String((parameter === null || parameter === void 0 ? void 0 : parameter.name) || '').trim(); });
        if (unnamed !== -1)
            return "Parameter " + (unnamed + 1) + " has no name.";
        var malformed = parameters.find(function (parameter) {
            return parameterNameError(parameter === null || parameter === void 0 ? void 0 : parameter.name);
        });
        if (malformed) {
            var name_1 = String(malformed.name).trim();
            return "Parameter \u201C" + name_1 + "\u201D: " + PARAMETER_NAME_HINT;
        }
        var missingPrompt = parameters.find(function (parameter) { return (parameter === null || parameter === void 0 ? void 0 : parameter.required) && !(parameter === null || parameter === void 0 ? void 0 : parameter.response_node_id); });
        if (missingPrompt) {
            return "Required parameter \u201C" + (String(missingPrompt.name || '').trim() || 'unnamed') + "\u201D needs a prompt response step.";
        }
    }
    if (node.type === 'condition') {
        var index = (((_d = node.config) === null || _d === void 0 ? void 0 : _d.conditions) || []).findIndex(function (condition) { return !String((condition === null || condition === void 0 ? void 0 : condition.parameter) || '').trim(); });
        if (index !== -1)
            return "Condition " + (index + 1) + " has no parameter.";
        var malformed = (((_e = node.config) === null || _e === void 0 ? void 0 : _e.conditions) || []).findIndex(function (condition) {
            return parameterNameError(condition === null || condition === void 0 ? void 0 : condition.parameter);
        });
        if (malformed !== -1) {
            return "Condition " + (malformed + 1) + ": " + PARAMETER_NAME_HINT;
        }
    }
    if (['tool_execution', 'fallback_node'].includes(node.type)) {
        // The backend's own message for this names a payload field the user
        // never sees, so catch it here in the editor's wording.
        var acknowledgement = ((_f = node.config) === null || _f === void 0 ? void 0 : _f.acknowledgement_config) || {};
        if (acknowledgement.type === 'custom' &&
            !acknowledgement.response_node_id) {
            return CUSTOM_ACK_MISSING;
        }
        // A code tool's parameters are filled from collected parameters by name,
        // so they follow the same naming rule.
        var definition = node.tool_definition || {};
        if (node.tool_source === 'agent_specific' && definition.mode !== 'rag') {
            var badName = Object.keys(((_g = definition.parameters) === null || _g === void 0 ? void 0 : _g.properties) || {}).find(function (name) { return parameterNameError(name); });
            if (badName !== undefined) {
                return "Tool parameter \u201C" + badName + "\u201D: " + PARAMETER_NAME_HINT;
            }
        }
    }
    return null;
};
// Inline message under a field, matching the duplicate step-name warning.
var FieldError = function (_a) {
    var children = _a.children;
    return (react_1["default"].createElement("span", { role: "alert", style: { display: 'block', marginTop: 4, color: '#b42318', fontSize: 11 } }, children));
};
var responseBody = function (response) { return (response === null || response === void 0 ? void 0 : response.body) || response || {}; };
// mogamboRequestV3 rejects on network failures and non-JSON responses, so every
// await needs a catch; this turns whatever it threw into something displayable.
var thrownMessage = function (error, fallback) {
    return error instanceof Error && error.message ? error.message : fallback;
};
var errorMessage = function (response, fallback) {
    var body = responseBody(response);
    if (typeof body.error === 'string')
        return body.error;
    if (body.error && typeof body.error === 'object') {
        // A validation failure often repeats its message inside `details`; show
        // each sentence once so a rejected save does not read as two errors.
        var message_1 = String(body.error.message || '').trim();
        var details = Array.isArray(body.error.details)
            ? Array.from(new Set(body.error.details
                .map(function (item) {
                return String(item.error || item.message || item.msg || '').trim();
            })
                .filter(function (detail) { return detail && !message_1.includes(detail); }))).join('; ')
            : '';
        return [message_1, details].filter(Boolean).join(' — ') || fallback;
    }
    if (typeof body.detail === 'string')
        return body.detail;
    if (Array.isArray(body.detail)) {
        // Workflow validation returns plain sentences; FastAPI's own schema errors
        // arrive as objects. Render either as something a person can act on, and
        // never surface the `loc` path, which names payload fields the builder
        // does not show.
        var messages = body.detail
            .map(function (item) {
            if (typeof item === 'string')
                return item.trim();
            var detailText = (item === null || item === void 0 ? void 0 : item.msg) || (item === null || item === void 0 ? void 0 : item.message) || (item === null || item === void 0 ? void 0 : item.error) || '';
            var field = Array.isArray(item === null || item === void 0 ? void 0 : item.loc)
                ? item.loc[item.loc.length - 1]
                : '';
            return field && detailText
                ? String(field).replace(/_/g, ' ') + ": " + detailText
                : String(detailText || '').trim();
        })
            .filter(Boolean);
        var unique = Array.from(new Set(messages));
        if (unique.length) {
            return unique.length === 1 ? unique[0] : unique.join('\n');
        }
    }
    return fallback;
};
// Workflows grow past what a plain <select> can be scanned in, so steps are
// picked from a searchable list ordered by name rather than by creation order.
var StepPicker = function (_a) {
    var label = _a.label, emptyLabel = _a.emptyLabel, steps = _a.steps, value = _a.value, _b = _a.withId, withId = _b === void 0 ? false : _b, onChange = _a.onChange;
    // Dropdown rebuilds its option state and its search index whenever this array
    // changes identity, so key the memo on the steps' contents rather than on the
    // freshly filtered array the parent hands down on every render.
    var signature = steps
        .map(function (step) { return step.id + ":" + step.node_name; })
        .join('|');
    var options = react_1["default"].useMemo(function () { return __spreadArrays([
        { id: '', name: emptyLabel }
    ], steps
        .map(function (step) { return ({
        id: String(step.id),
        name: withId
            ? (step.node_name || "Step " + step.id) + " (ID " + step.id + ")"
            : step.node_name || "Step " + step.id,
    }); })
        .sort(function (first, second) {
        return first.name.localeCompare(second.name, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    })); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [signature, emptyLabel, withId]);
    var current = options.find(function (option) { return option.id === String(value !== null && value !== void 0 ? value : ''); }) || options[0];
    return (react_1["default"].createElement("div", { style: { marginTop: 12 } },
        react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, optionKey: "name", label: label, placeholder: emptyLabel, noOptionsText: "No matching steps", options: options, value: current, onChange: function (option) { var _a; return onChange((_a = option === null || option === void 0 ? void 0 : option.id) !== null && _a !== void 0 ? _a : ''); } })));
};
// Mirrors the provider/model pair on the agents page: models are filtered by the
// chosen provider, and changing the provider clears a model that no longer fits.
var ModelPicker = function (_a) {
    var models = _a.models, provider = _a.provider, model = _a.model, onChange = _a.onChange;
    var providerOptions = react_1["default"].useMemo(function () {
        var providers = new Set();
        (models || []).forEach(function (item) {
            var _a;
            var itemProvider = (_a = item === null || item === void 0 ? void 0 : item['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            if (itemProvider)
                providers.add(String(itemProvider));
        });
        return Array.from(providers).map(function (itemProvider) { return ({
            id: itemProvider,
            name: itemProvider,
        }); });
    }, [models]);
    var modelOptions = react_1["default"].useMemo(function () {
        return (models || [])
            .filter(function (item) {
            var _a;
            if (!provider)
                return true;
            return ((_a = item === null || item === void 0 ? void 0 : item['meta_data']) === null || _a === void 0 ? void 0 : _a.provider) === provider;
        })
            .map(function (item) {
            var _a, _b;
            return ({
                id: (_a = item === null || item === void 0 ? void 0 : item.name) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.id,
                name: (_b = item === null || item === void 0 ? void 0 : item.name) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.id,
                catalogId: item === null || item === void 0 ? void 0 : item.id,
                modelType: (item === null || item === void 0 ? void 0 : item.model_type) || 'llm',
            });
        })
            .filter(function (item) { return item.id; });
    }, [models, provider]);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { style: { marginTop: 12 } },
            react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, optionKey: "name", label: "Provider", placeholder: "Select a model provider", noOptionsText: "No providers available", options: providerOptions, value: providerOptions.find(function (item) { return item.id === provider; }) ||
                    (provider ? { id: provider, name: provider } : {}), onChange: function (option) { var _a; return onChange({ provider: (_a = option === null || option === void 0 ? void 0 : option.id) !== null && _a !== void 0 ? _a : '', model: '' }); } })),
        react_1["default"].createElement("div", { style: { marginTop: 12 } },
            react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, optionKey: "name", label: "Model", placeholder: "Select a model", noOptionsText: "No models for this provider", options: modelOptions, value: modelOptions.find(function (item) { return item.id === model; }) ||
                    (model ? { id: model, name: model } : {}), onChange: function (option) {
                    var _a, _b, _c;
                    return onChange({
                        id: (_a = option === null || option === void 0 ? void 0 : option.catalogId) !== null && _a !== void 0 ? _a : '',
                        type: (_b = option === null || option === void 0 ? void 0 : option.modelType) !== null && _b !== void 0 ? _b : 'llm',
                        provider: provider,
                        model: (_c = option === null || option === void 0 ? void 0 : option.id) !== null && _c !== void 0 ? _c : '',
                    });
                } }))));
};
var WorkflowAgentBuilder = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
    var domainId = _a.domainId, agentId = _a.agentId, agentName = _a.agentName, languages = _a.languages, voiceModels = _a.voiceModels, audioRegenerationInProgress = _a.audioRegenerationInProgress, audioRegenerationFailed = _a.audioRegenerationFailed, onClose = _a.onClose;
    var availableLanguages = react_1["default"].useMemo(function () {
        return (languages || [])
            .filter(function (language) { return language === null || language === void 0 ? void 0 : language.code; })
            .map(function (language) { return ({
            code: String(language.code),
            name: language.name || String(language.code),
        }); });
    }, [languages]);
    // A response saved before a language was removed from the bot still has to
    // render, so fall back to its raw code rather than hiding it.
    var languageNameFor = function (code) { var _a; return ((_a = availableLanguages.find(function (language) { return language.code === code; })) === null || _a === void 0 ? void 0 : _a.name) || code; };
    var defaultLanguageCode = ((_b = availableLanguages[0]) === null || _b === void 0 ? void 0 : _b.code) || 'en';
    // A variation saved before its language was removed from the bot is kept,
    // but shown read-only: the call never speaks it. Until the bot's languages
    // have loaded, every language counts as supported.
    var isSupportedLanguage = function (code) {
        return !availableLanguages.length ||
            availableLanguages.some(function (language) { return language.code === code; });
    };
    // Parameter extraction keeps using the voice-model catalogue. Intent
    // detection has its own capability-filtered catalogue so it can offer both
    // LLMs and specialised decision models without exposing JEV as an agent LLM.
    var _26 = react_1["default"].useState([]), fetchedModels = _26[0], setFetchedModels = _26[1];
    var _27 = react_1["default"].useState([]), fetchedIntentModels = _27[0], setFetchedIntentModels = _27[1];
    var models = (voiceModels === null || voiceModels === void 0 ? void 0 : voiceModels.length) ? voiceModels : fetchedModels;
    var intentModels = fetchedIntentModels;
    // Seeding a step with a model the bot does not have would show an empty
    // dropdown over a config that still carries the stale value, so start from
    // whatever the bot actually offers and let validation ask if there is nothing.
    var defaultAiModel = react_1["default"].useMemo(function () {
        var _a, _b;
        var first = (models || []).find(function (model) { var _a, _b; return ((_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider) && ((_b = model === null || model === void 0 ? void 0 : model.name) !== null && _b !== void 0 ? _b : model === null || model === void 0 ? void 0 : model.id); });
        return first
            ? {
                provider: String((_a = first === null || first === void 0 ? void 0 : first['meta_data']) === null || _a === void 0 ? void 0 : _a.provider),
                model: String((_b = first.name) !== null && _b !== void 0 ? _b : first.id),
            }
            : { provider: '', model: '' };
    }, [models]);
    var _28 = react_1["default"].useState([]), nodes = _28[0], setNodes = _28[1];
    var _29 = react_1["default"].useState(null), selectedId = _29[0], setSelectedId = _29[1];
    var _30 = react_1["default"].useState(null), focusedId = _30[0], setFocusedId = _30[1];
    var _31 = react_1["default"].useState('Loading workflow…'), status = _31[0], setStatus = _31[1];
    var _32 = react_1["default"].useState(false), saving = _32[0], setSaving = _32[1];
    var _33 = react_1["default"].useState(null), generatingResponseIndex = _33[0], setGeneratingResponseIndex = _33[1];
    var _34 = react_1["default"].useState(null), playingResponseIndex = _34[0], setPlayingResponseIndex = _34[1];
    // Languages whose bot voice cannot pre-generate audio. The response-url
    // endpoint answers live_tts: true for them, and Call Genie then speaks the
    // text live during the call, so there is no clip to play or regenerate. The
    // answer depends on the voice, not on one response, so it is kept per
    // language for the session.
    var _35 = react_1["default"].useState(new Set()), liveTtsLanguages = _35[0], setLiveTtsLanguages = _35[1];
    var markLiveTts = function (languageCode) {
        return setLiveTtsLanguages(function (current) {
            return current.has(languageCode) ? current : new Set(current).add(languageCode);
        });
    };
    // A response with {placeholders} is always spoken live and already says so;
    // these cover static text, which only a live-TTS voice leaves without audio.
    var isStaticText = function (response) {
        return !/\{[A-Za-z_][A-Za-z0-9_]*\}/.test(response.response || '');
    };
    var isSpokenLive = function (response) {
        return isStaticText(response) &&
            liveTtsLanguages.has(response.language_code || 'en');
    };
    var hasAudioPreview = function (response) {
        return isStaticText(response) && !isSpokenLive(response);
    };
    var _36 = react_1["default"].useState(null), codeEditorNodeId = _36[0], setCodeEditorNodeId = _36[1];
    // Language whose extra RAG instruction is being edited on a RAG step.
    var _37 = react_1["default"].useState(''), ragPromptLanguage = _37[0], setRagPromptLanguage = _37[1];
    var _38 = react_1["default"].useState(new Set()), dirtyNodeIds = _38[0], setDirtyNodeIds = _38[1];
    var _39 = react_1["default"].useState(new Set()), collapsedLanguages = _39[0], setCollapsedLanguages = _39[1];
    var _40 = react_1["default"].useState(false), isAddingLanguage = _40[0], setIsAddingLanguage = _40[1];
    var _41 = react_1["default"].useState(''), newLanguageCode = _41[0], setNewLanguageCode = _41[1];
    var _42 = react_1["default"].useState('{}'), toolParameters = _42[0], setToolParameters = _42[1];
    var _43 = react_1["default"].useState([]), agents = _43[0], setAgents = _43[1];
    var _44 = react_1["default"].useState([]), tools = _44[0], setTools = _44[1];
    var reduxDispatch = react_redux_1.useDispatch();
    var envVariables = react_redux_1.useSelector(selectors_1.getEnvVariables);
    var botSettings = react_redux_1.useSelector(selectors_1.getDomainData);
    var canEditEnvVariables = _utils_1.userHasPermission(const_2.PERMISSION_LEVELS.EDIT_ENV_VARIABLES);
    var _45 = react_1["default"].useState({}), codeTypeDraft = _45[0], setCodeTypeDraft = _45[1];
    var _46 = react_1["default"].useState(1), zoom = _46[0], setZoom = _46[1];
    var _47 = react_1["default"].useState(null), connecting = _47[0], setConnecting = _47[1];
    var _48 = react_1["default"].useState(null), connectionPoint = _48[0], setConnectionPoint = _48[1];
    var _49 = react_1["default"].useState(null), edgeMenu = _49[0], setEdgeMenu = _49[1];
    var _50 = react_1["default"].useState(null), nodeMenu = _50[0], setNodeMenu = _50[1];
    var _51 = react_1["default"].useState(null), selectedEdge = _51[0], setSelectedEdge = _51[1];
    var _52 = react_1["default"].useState({ left: 0, top: 0 }), canvasScroll = _52[0], setCanvasScroll = _52[1];
    var _53 = react_1["default"].useState(false), isPanning = _53[0], setIsPanning = _53[1];
    var _54 = react_1["default"].useState(false), spaceHeld = _54[0], setSpaceHeld = _54[1];
    // The click that ends a pan must not deselect the step or open another one.
    var panJustEndedRef = react_1["default"].useRef(false);
    var canvasRef = react_1["default"].useRef(null);
    var rootRef = react_1["default"].useRef(null);
    var contentRef = react_1["default"].useRef(null);
    // The canvas origin, in step coordinates: 0 unless a step (or a dragged
    // connection bend) sits left of / above 0, in which case the canvas grows
    // that way so the step stays reachable, like it already grows right/down.
    var graphOrigin = nodes.reduce(function (origin, node) {
        var _a;
        var points = Object.values(((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.edge_points) || {});
        return {
            x: Math.min.apply(Math, __spreadArrays([origin.x,
                Number(node.position_x || 0)], points.map(function (point) { return Number((point === null || point === void 0 ? void 0 : point.x) || 0); }))),
            y: Math.min.apply(Math, __spreadArrays([origin.y,
                Number(node.position_y || 0)], points.map(function (point) { return Number((point === null || point === void 0 ? void 0 : point.y) || 0); }))),
        };
    }, { x: 0, y: 0 });
    var graphOriginX = graphOrigin.x < 0
        ? Math.floor(graphOrigin.x / GRAPH_ORIGIN_STEP) * GRAPH_ORIGIN_STEP
        : 0;
    var graphOriginY = graphOrigin.y < 0
        ? Math.floor(graphOrigin.y / GRAPH_ORIGIN_STEP) * GRAPH_ORIGIN_STEP
        : 0;
    // Step coordinates <-> the scroll container's coordinates at a zoom level.
    var toScrollX = function (x, atZoom) {
        if (atZoom === void 0) { atZoom = zoom; }
        return CANVAS_GUTTER_X + (x - graphOriginX) * atZoom;
    };
    var toScrollY = function (y, atZoom) {
        if (atZoom === void 0) { atZoom = zoom; }
        return CANVAS_GUTTER_Y + (y - graphOriginY) * atZoom;
    };
    var fromScrollX = function (scrollX) {
        return (scrollX - CANVAS_GUTTER_X) / zoom + graphOriginX;
    };
    var fromScrollY = function (scrollY) {
        return (scrollY - CANVAS_GUTTER_Y) / zoom + graphOriginY;
    };
    // When the origin moves (a step dragged further left or up), everything
    // shifts right/down inside the scroll area. Scroll by the same amount so
    // the view, and the step under the pointer, stay where they are.
    var previousGraphOriginRef = react_1["default"].useRef({
        x: graphOriginX,
        y: graphOriginY,
    });
    react_1["default"].useLayoutEffect(function () {
        var previous = previousGraphOriginRef.current;
        previousGraphOriginRef.current = { x: graphOriginX, y: graphOriginY };
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        canvas.scrollLeft += (previous.x - graphOriginX) * zoom;
        canvas.scrollTop += (previous.y - graphOriginY) * zoom;
        // Only an origin change should scroll; zoom handles its own scrolling.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [graphOriginX, graphOriginY]);
    var focusTimerRef = react_1["default"].useRef(undefined);
    // Step point to centre on once a freshly loaded workflow has rendered.
    var pendingLandingRef = react_1["default"].useRef(null);
    // A click that closes out a drag must not be read as "open this step".
    var dragJustEndedRef = react_1["default"].useRef(false);
    var previewAudioRef = react_1["default"].useRef(null);
    var _55 = react_1["default"].useState([]), toasts = _55[0], setToasts = _55[1];
    var toastIdRef = react_1["default"].useRef(0);
    var toastTimersRef = react_1["default"].useRef(new Set());
    // Pending dismiss timers must not fire after the builder has closed.
    react_1["default"].useEffect(function () { return function () {
        toastTimersRef.current.forEach(function (timer) { return window.clearTimeout(timer); });
    }; }, []);
    // The step on screen right now, read after an await to tell whether the
    // user moved to another step while audio was being generated.
    var selectedIdRef = react_1["default"].useRef(null);
    selectedIdRef.current = selectedId;
    var paletteDraggedRef = react_1["default"].useRef(false);
    var connectionJustDroppedRef = react_1["default"].useRef(false);
    var selected = nodes.find(function (node) { return String(node.id) === String(selectedId); });
    var selectedIntentModel = ((_c = selected === null || selected === void 0 ? void 0 : selected.config) === null || _c === void 0 ? void 0 : _c.intent_model) ||
        ((selected === null || selected === void 0 ? void 0 : selected.type) === 'intent_detection' && ((_d = selected === null || selected === void 0 ? void 0 : selected.config) === null || _d === void 0 ? void 0 : _d.ai_model)
            ? __assign(__assign({}, selected.config.ai_model), { type: 'llm' }) : {});
    var existingEntryNode = nodes.find(function (node) { return node.is_entry && String(node.id) !== String(selectedId); });
    var implicitStartNode = implicitStartNodeFor(nodes);
    var isImplicitStart = function (node) {
        return Boolean(node && implicitStartNode) &&
            String(node === null || node === void 0 ? void 0 : node.id) === String(implicitStartNode === null || implicitStartNode === void 0 ? void 0 : implicitStartNode.id);
    };
    var duplicateNameNode = selected
        ? nodes.find(function (node) {
            return String(node.id) !== String(selected.id) &&
                String(node.node_name || '')
                    .trim()
                    .toLowerCase() ===
                    String(selected.node_name || '')
                        .trim()
                        .toLowerCase() &&
                String(node.node_name || '').trim();
        })
        : undefined;
    var selectedMappedTool = tools.find(function (tool) { return String(tool.id) === String(selected === null || selected === void 0 ? void 0 : selected.tool_id); });
    var selectedToolMode = ((_e = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _e === void 0 ? void 0 : _e.mode) || (selectedMappedTool === null || selectedMappedTool === void 0 ? void 0 : selectedMappedTool.mode);
    var selectedToolTarget = ((_f = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _f === void 0 ? void 0 : _f.target_agent) || (selectedMappedTool === null || selectedMappedTool === void 0 ? void 0 : selectedMappedTool.target_agent);
    var isFallbackNode = (selected === null || selected === void 0 ? void 0 : selected.type) === 'fallback_node';
    // code_type is never persisted - not for agent tools either - so the choice
    // lives here for the session and getToolCallCodeType infers it from the
    // code-executor function on reload.
    // A step with nothing pending must not offer a save. A draft has never been
    // written, so it always counts as pending.
    var selectedHasUnsavedChanges = Boolean(selected && (selected._draft || dirtyNodeIds.has(String(selected.id))));
    var selectedCodeType = codeTypeDraft[String(selected === null || selected === void 0 ? void 0 : selected.id)] ||
        VoiceAgentLayoutUtils_1.getToolCallCodeType(selected === null || selected === void 0 ? void 0 : selected.tool_definition);
    var selectedBehaviourId = (((_g = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _g === void 0 ? void 0 : _g.mode) || (isFallbackNode ? 'handoff' : '')) ===
        'tool_call'
        ? "tool_call_" + selectedCodeType
        : ((_h = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _h === void 0 ? void 0 : _h.mode) ||
            (isFallbackNode ? 'handoff' : 'tool_call_advanced');
    var isFaqHandoff = selectedToolMode === 'handoff' &&
        agents.some(function (agent) { return agent.name === selectedToolTarget && agent.role === 'faq'; });
    // A language can have more than one response: the runtime picks one at
    // random per call so the bot doesn't repeat the exact same phrasing every
    // time. Variations are identified by id (assigned once saved), not a name.
    var responseGroups = Object.entries(((selected === null || selected === void 0 ? void 0 : selected.responses) || []).reduce(function (groups, response, index) {
        var languageCode = response.language_code || 'en';
        if (!groups[languageCode])
            groups[languageCode] = [];
        groups[languageCode].push({ response: response, index: index });
        return groups;
    }, {}));
    var unusedLanguages = availableLanguages.filter(function (language) {
        return !responseGroups.some(function (_a) {
            var languageCode = _a[0];
            return languageCode === language.code;
        });
    });
    // Unsaved Bot Response steps are offered too; picking one saves it first,
    // because a processing message can only point at a step with a server id.
    var responseSteps = nodes.filter(function (node) { return node.type === 'bot_response'; });
    var responseReferences = function (responseNodeId) {
        return nodes.flatMap(function (source) {
            var _a, _b;
            var references = [];
            if (source.type === 'capture_parameter') {
                (((_a = source.config) === null || _a === void 0 ? void 0 : _a.parameters) || []).forEach(function (parameter) {
                    if (String(parameter.response_node_id) === String(responseNodeId)) {
                        references.push({
                            source: source,
                            label: "Parameter prompt \u00B7 " + (parameter.name || 'Unnamed parameter'),
                        });
                    }
                });
            }
            var acknowledgement = ((_b = source.config) === null || _b === void 0 ? void 0 : _b.acknowledgement_config) || {};
            if (['tool_execution', 'fallback_node'].includes(source.type) &&
                acknowledgement.type === 'custom' &&
                String(acknowledgement.response_node_id) === String(responseNodeId)) {
                references.push({ source: source, label: 'Tool processing message' });
            }
            return references;
        });
    };
    // Navigating to a step brings it into view and marks it briefly. Opening its
    // editor is reserved for clicking the step itself.
    var focusNode = function (node) {
        setFocusedId(node.id);
        window.clearTimeout(focusTimerRef.current);
        focusTimerRef.current = window.setTimeout(function () { return setFocusedId(null); }, FOCUS_HIGHLIGHT_MS);
        requestAnimationFrame(function () {
            var target = centreScrollFor(Number(node.position_x || 0) + NODE_WIDTH / 2, Number(node.position_y || 0) + NODE_HEIGHT / 2);
            if (!canvasRef.current || !target)
                return;
            canvasRef.current.scrollLeft = target.left;
            canvasRef.current.scrollTop = target.top;
        });
    };
    var canvasPointFrom = function (clientX, clientY) {
        var content = contentRef.current;
        if (!content)
            return null;
        var bounds = content.getBoundingClientRect();
        return {
            // The content is translated by the origin, so its box already starts
            // at the origin: a point inside it maps straight to step coordinates.
            x: (clientX - bounds.left) / zoom,
            y: (clientY - bounds.top) / zoom,
        };
    };
    var visibleCentre = function () {
        var canvas = canvasRef.current;
        if (!canvas)
            return null;
        return {
            x: fromScrollX(canvas.scrollLeft + (canvas.clientWidth + PALETTE_OVERLAY_WIDTH) / 2),
            y: fromScrollY(canvas.scrollTop + canvas.clientHeight / 2),
        };
    };
    // Scroll offsets that put a canvas point in the middle of the area the
    // floating palette does not cover.
    var centreScrollFor = function (canvasX, canvasY, atZoom) {
        if (atZoom === void 0) { atZoom = zoom; }
        var canvas = canvasRef.current;
        if (!canvas)
            return null;
        return {
            left: Math.max(0, toScrollX(canvasX, atZoom) -
                (canvas.clientWidth + PALETTE_OVERLAY_WIDTH) / 2),
            top: Math.max(0, toScrollY(canvasY, atZoom) - canvas.clientHeight / 2),
        };
    };
    var zoomTo = function (value, anchor) {
        var nextZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, value));
        var wrap = canvasRef.current;
        if (!wrap || nextZoom === zoom) {
            setZoom(nextZoom);
            return;
        }
        // Without an anchor, hold the middle of the visible canvas still so the
        // zoom controls scale about what the user is looking at.
        var focusX = anchor ? anchor.x : wrap.clientWidth / 2;
        var focusY = anchor ? anchor.y : wrap.clientHeight / 2;
        var canvasX = fromScrollX(focusX + wrap.scrollLeft);
        var canvasY = fromScrollY(focusY + wrap.scrollTop);
        setZoom(nextZoom);
        requestAnimationFrame(function () {
            wrap.scrollLeft = Math.max(0, toScrollX(canvasX, nextZoom) - focusX);
            wrap.scrollTop = Math.max(0, toScrollY(canvasY, nextZoom) - focusY);
        });
    };
    // An outcome the user needs to notice - a save, a delete, a rejected action -
    // shows as a small message at the bottom of the canvas. The app's shared
    // toast dims and blocks the whole screen until it is dismissed, which gets
    // in the way while building, so the builder keeps its own messages and the
    // shared toast is left unchanged for every other page. The canvas status
    // line stays for passive hints that belong beside what they describe.
    var showToast = function (message, tone, timeout) {
        toastIdRef.current += 1;
        var id = toastIdRef.current;
        // Keep at most three on screen, and don't stack the same message twice.
        setToasts(function (current) { return __spreadArrays(current
            .filter(function (toast) { return toast.message !== message || toast.tone !== tone; })
            .slice(-2), [
            { id: id, message: message, tone: tone },
        ]); });
        var timer = window.setTimeout(function () {
            toastTimersRef.current["delete"](timer);
            setToasts(function (current) { return current.filter(function (toast) { return toast.id !== id; }); });
        }, timeout);
        toastTimersRef.current.add(timer);
    };
    var dismissToast = function (id) {
        return setToasts(function (current) { return current.filter(function (toast) { return toast.id !== id; }); });
    };
    var notifyDone = function (message) {
        return showToast(message, 'success', SUCCESS_TOAST_MS);
    };
    var notifyFailed = function (message) {
        return showToast(message, 'error', NOTICE_TOAST_MS);
    };
    // Every destructive action asks through the app's own confirmation dialog,
    // the same pop-up the agents page uses, rather than the browser's confirm.
    var confirmAction = function (_a) {
        var title = _a.title, message = _a.message, okTitle = _a.okTitle, _b = _a.cancelTitle, cancelTitle = _b === void 0 ? 'Cancel' : _b, onOk = _a.onOk;
        return BotActions_1.showConfirmationDialog({
            title: title,
            message: message,
            okTitle: okTitle,
            cancelTitle: cancelTitle,
            okActionType: 'danger',
            onCancel: function () { },
            onOk: onOk,
        });
    };
    var loadNodes = react_1["default"].useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var nodeResult, agentResult, error_1, agentBody, workflowAgents, workflowAgent, agentTools, commonTools, loaded, landing;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all([
                            api_1.getWorkflowNodes(domainId, agentId),
                            api_1.getWorkflowAgents(domainId),
                        ])];
                case 1:
                    _a = _b.sent(), nodeResult = _a[0], agentResult = _a[1];
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    notifyFailed(thrownMessage(error_1, 'Unable to load workflow.'));
                    return [2 /*return*/];
                case 3:
                    if (!nodeResult.success) {
                        notifyFailed(errorMessage(nodeResult.response, 'Unable to load workflow.'));
                        return [2 /*return*/];
                    }
                    agentBody = responseBody(agentResult.response);
                    workflowAgents = agentBody.agents || [];
                    workflowAgent = workflowAgents.find(function (agent) { return String(agent.id || agent.db_id) === String(agentId); });
                    agentTools = (workflowAgent === null || workflowAgent === void 0 ? void 0 : workflowAgent.tools) || [];
                    commonTools = (agentBody.common_tools || []).map(function (tool) { return (__assign(__assign({}, tool), { _common: true })); });
                    setAgents(workflowAgents);
                    setTools(__spreadArrays(agentTools, commonTools.filter(function (common) {
                        return !agentTools.some(function (tool) { return String(tool.id) === String(common.id); });
                    })));
                    loaded = responseBody(nodeResult.response).nodes || [];
                    landing = loaded.find(function (node) { return node.is_entry; }) || implicitStartNodeFor(loaded);
                    pendingLandingRef.current = {
                        x: Number((landing === null || landing === void 0 ? void 0 : landing.position_x) || 0) + NODE_WIDTH / 2,
                        y: Number((landing === null || landing === void 0 ? void 0 : landing.position_y) || 0) + NODE_HEIGHT / 2,
                    };
                    setNodes(loaded.map(withPersistedSnapshot));
                    if (agentResult.success) {
                        setStatus('');
                    }
                    else {
                        setStatus('Workflow loaded; tools unavailable.');
                        showToast('Workflow loaded, but its tools could not be fetched.', 'warning', NOTICE_TOAST_MS);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [agentId, domainId]);
    react_1["default"].useEffect(function () {
        loadNodes();
    }, [loadNodes]);
    // Centring runs after the loaded steps render: the scroll position depends
    // on the graph origin, which loadNodes cannot see because it was created
    // before the steps arrived.
    react_1["default"].useEffect(function () {
        var point = pendingLandingRef.current;
        if (!point)
            return;
        pendingLandingRef.current = null;
        requestAnimationFrame(function () {
            var target = centreScrollFor(point.x, point.y);
            if (!canvasRef.current || !target)
                return;
            canvasRef.current.scrollLeft = target.left;
            canvasRef.current.scrollTop = target.top;
        });
        // Only a fresh load should centre; centreScrollFor is recreated each render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodes]);
    // A voice change rebuilds every static clip in the background, which leaves
    // the canvas holding the response URLs from before the rebuild ran. Saving a
    // step then writes those stale URLs back over the audio that was just
    // generated, undoing it with no error anywhere. So when a rebuild finishes,
    // take the new URLs.
    //
    // Only the URLs are taken. A step edited while the rebuild was running keeps
    // its edits, because reloading the workflow outright would discard them.
    var wasRegeneratingRef = react_1["default"].useRef(Boolean(audioRegenerationInProgress));
    react_1["default"].useEffect(function () {
        var isRegenerating = Boolean(audioRegenerationInProgress);
        var justFinished = wasRegeneratingRef.current && !isRegenerating;
        wasRegeneratingRef.current = isRegenerating;
        if (!justFinished || !domainId || !agentId)
            return undefined;
        // A rebuild follows a voice change, and the new voice may be able to
        // pre-generate audio where the old one could not, so ask again.
        setLiveTtsLanguages(new Set());
        var cancelled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, error_2, urlByResponseId, refreshResponses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.getWorkflowNodes(domainId, agentId)];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        // The canvas keeps the URLs it has; the next load corrects them.
                        return [2 /*return*/];
                    case 3:
                        if (cancelled || !(result === null || result === void 0 ? void 0 : result.success))
                            return [2 /*return*/];
                        urlByResponseId = new Map();
                        (responseBody(result.response).nodes || []).forEach(function (node) {
                            return (node.responses || []).forEach(function (response) {
                                var _a;
                                if (response === null || response === void 0 ? void 0 : response.id) {
                                    urlByResponseId.set(String(response.id), (_a = response.response_url) !== null && _a !== void 0 ? _a : null);
                                }
                            });
                        });
                        if (!urlByResponseId.size)
                            return [2 /*return*/];
                        refreshResponses = function (responses) {
                            return (responses || []).map(function (response) {
                                return (response === null || response === void 0 ? void 0 : response.id) && urlByResponseId.has(String(response.id))
                                    ? __assign(__assign({}, response), { response_url: urlByResponseId.get(String(response.id)) }) : response;
                            });
                        };
                        setNodes(function (current) {
                            return current.map(function (node) { return (__assign(__assign(__assign({}, node), { responses: refreshResponses(node.responses) }), (node._persisted
                                ? {
                                    _persisted: __assign(__assign({}, node._persisted), { responses: refreshResponses(node._persisted.responses) }),
                                }
                                : {}))); });
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            cancelled = true;
        };
    }, [audioRegenerationInProgress, domainId, agentId]);
    // Same fetch the agents page performs before opening a code editor, so a
    // workflow tool can read the bot's environment variables too.
    react_1["default"].useEffect(function () {
        if (!domainId)
            return undefined;
        var current = true;
        reduxDispatch(actions_2.setEnvVariables([]));
        api_1.fetchEnvVariables(domainId)
            .then(function (_a) {
            var _b;
            var success = _a.success, response = _a.response;
            if (!current)
                return;
            var fetched = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.env_variables;
            if (success && fetched)
                reduxDispatch(actions_2.setEnvVariables(fetched));
        })["catch"](function () { });
        return function () {
            current = false;
        };
    }, [domainId, reduxDispatch]);
    var runToolCode = function (inputJson, callback) {
        actions_1.runCodeNodeData('', inputJson, function (success, error) {
            if (error && callback)
                callback(error);
            if (success)
                notifyDone('Code run completed.');
            else
                notifyFailed('Code run failed.');
        });
    };
    var saveToolCodeWithVariables = function (variables, code, callback) {
        if (callback === void 0) { callback = function () { }; }
        if (!_utils_1.userHasPermission(const_2.PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
            callback(false);
            notifyFailed('You do not have permissions to do this');
            return;
        }
        if (!canEditEnvVariables) {
            notifyFailed('Not Valid Permissions');
            callback(false);
            return;
        }
        reduxDispatch(actions_2.setEnvVariables(variables));
        updateToolDefinition({ code: code });
        utils_1.saveEnvVariablesForActions(String(domainId), variables)
            .then(function () {
            notifyDone('Environment variables saved.');
            callback(true);
        })["catch"](function (error) {
            notifyFailed(String((error === null || error === void 0 ? void 0 : error.message) || error));
            callback(false);
        });
    };
    react_1["default"].useEffect(function () {
        if (voiceModels === null || voiceModels === void 0 ? void 0 : voiceModels.length)
            return;
        api_1.getVoiceModels()
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success)
                return;
            var body = responseBody(response);
            setFetchedModels(Array.isArray(body) ? body : (body === null || body === void 0 ? void 0 : body.models) || (body === null || body === void 0 ? void 0 : body.data) || []);
        })["catch"](function () { return setFetchedModels([]); });
    }, [voiceModels]);
    react_1["default"].useEffect(function () {
        api_1.getIntentDetectionModels(domainId)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success)
                return;
            var body = responseBody(response);
            setFetchedIntentModels(Array.isArray(body) ? body : (body === null || body === void 0 ? void 0 : body.models) || (body === null || body === void 0 ? void 0 : body.data) || []);
        })["catch"](function () { return setFetchedIntentModels([]); });
    }, [domainId]);
    react_1["default"].useEffect(function () {
        if (!status || status.includes('…'))
            return undefined;
        var timeout = window.setTimeout(function () { return setStatus(''); }, 4500);
        return function () { return window.clearTimeout(timeout); };
    }, [status]);
    react_1["default"].useEffect(function () {
        var _a;
        setToolParameters(JSON.stringify(((_a = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) || {}, null, 2));
    }, [selectedId]);
    // The builder is mounted inside a padded, scrolling page shell. Drop that
    // padding and its scrollbar for as long as the canvas is open, and hand the
    // shell back exactly as it was on the way out.
    //
    // The shell sets only overflowY, so reading `overflow` gives '' and writing
    // that back wipes overflowY too, leaving the agents page unable to scroll.
    // Each axis is saved and restored on its own, after the shorthand.
    react_1["default"].useEffect(function () {
        var _a;
        var shell = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (!shell)
            return undefined;
        var previous = {
            padding: shell.style.padding,
            overflow: shell.style.overflow,
            overflowX: shell.style.overflowX,
            overflowY: shell.style.overflowY,
        };
        shell.style.padding = '0';
        shell.style.overflow = 'hidden';
        return function () {
            shell.style.padding = previous.padding;
            shell.style.overflow = previous.overflow;
            shell.style.overflowX = previous.overflowX;
            shell.style.overflowY = previous.overflowY;
        };
    }, []);
    var stopPreviewAudio = react_1["default"].useCallback(function () {
        if (previewAudioRef.current)
            previewAudioRef.current.pause();
        previewAudioRef.current = null;
        setPlayingResponseIndex(null);
    }, []);
    // Response indices belong to the selected step, so preview playback must not
    // outlive either the selection or the builder itself.
    react_1["default"].useEffect(function () { return stopPreviewAudio; }, [selectedId, stopPreviewAudio]);
    react_1["default"].useEffect(function () { return function () { return window.clearTimeout(focusTimerRef.current); }; }, []);
    // Holding Space turns any drag on the canvas into a pan, as in most design
    // tools. Keys typed into a field, or pressed on a button or in a dialog,
    // are left alone so Space still types and still activates them.
    react_1["default"].useEffect(function () {
        var isOwnedByControl = function (target) {
            var _a;
            var element = target;
            return Boolean((element === null || element === void 0 ? void 0 : element.isContentEditable) || ((_a = element === null || element === void 0 ? void 0 : element.closest) === null || _a === void 0 ? void 0 : _a.call(element, 'input, textarea, select, button, [role="dialog"]')));
        };
        var onKeyDown = function (event) {
            if (event.code !== 'Space' || isOwnedByControl(event.target))
                return;
            event.preventDefault();
            setSpaceHeld(true);
        };
        var onKeyUp = function (event) {
            if (event.code === 'Space')
                setSpaceHeld(false);
        };
        var release = function () { return setSpaceHeld(false); };
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
        window.addEventListener('blur', release);
        return function () {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('keyup', onKeyUp);
            window.removeEventListener('blur', release);
        };
    }, []);
    // Pans by scrolling the canvas. A left drag pans only from empty canvas, so
    // steps, connectors and connections keep their own drags; Space + drag and a
    // middle-button drag pan from anywhere on the canvas.
    var startPan = function (event) {
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        var target = event.target;
        var onBackground = target === canvas ||
            target === contentRef.current ||
            target.tagName.toLowerCase() === 'svg';
        var isMiddle = event.button === 1;
        if (!isMiddle && !(event.button === 0 && (spaceHeld || onBackground))) {
            return;
        }
        // Stop the press reaching a step underneath, whose own handler would
        // start dragging the step instead, and stop text selection.
        event.preventDefault();
        event.stopPropagation();
        var startX = event.clientX;
        var startY = event.clientY;
        var originLeft = canvas.scrollLeft;
        var originTop = canvas.scrollTop;
        var moved = false;
        var onMove = function (moveEvent) {
            var deltaX = moveEvent.clientX - startX;
            var deltaY = moveEvent.clientY - startY;
            if (!moved && Math.hypot(deltaX, deltaY) < PAN_THRESHOLD_PX)
                return;
            moved = true;
            setIsPanning(true);
            canvas.scrollLeft = originLeft - deltaX;
            canvas.scrollTop = originTop - deltaY;
        };
        var onUp = function () {
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            setIsPanning(false);
            // A middle-button release fires no click, so there is nothing to skip.
            if (!moved || isMiddle)
                return;
            panJustEndedRef.current = true;
            // The click follows pointerup straight away; clear the flag after it
            // so a pan that produced no click cannot swallow the next one.
            window.setTimeout(function () {
                panJustEndedRef.current = false;
            }, 0);
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
    };
    // Closing or reloading the tab, or leaving the dashboard altogether, would
    // drop unsaved steps without a word. Only for these the browser shows its
    // own prompt: pages are not allowed to replace it with their own dialog.
    var hasDirtyNodes = dirtyNodeIds.size > 0;
    react_1["default"].useEffect(function () {
        if (!hasDirtyNodes)
            return undefined;
        var warn = function (event) {
            event.preventDefault();
            // Chrome still needs returnValue set to show the prompt.
            // eslint-disable-next-line no-param-reassign
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', warn);
        return function () { return window.removeEventListener('beforeunload', warn); };
    }, [hasDirtyNodes]);
    // Moving elsewhere inside the dashboard (the sidebar, or the browser's back
    // button between dashboard pages) is a route change. Hold it and ask with
    // the app's own dialog, the way the node editor drawer does. Returning
    // false blocks quietly; returning a string would open the browser's prompt.
    react_1["default"].useEffect(function () {
        if (!hasDirtyNodes)
            return undefined;
        var unblock = History_1["default"].block(function (location) {
            confirmAction({
                title: 'Leave the workflow builder?',
                message: 'Unsaved changes to your steps will be lost if you leave.',
                okTitle: 'Leave',
                cancelTitle: 'Keep Editing',
                onOk: function () {
                    unblock();
                    History_1["default"].push(location);
                },
            });
            return false;
        });
        return unblock;
    }, [hasDirtyNodes]);
    // Response indices are positions within the selected step, so a pending
    // generation must not keep marking the same row on a different step.
    react_1["default"].useEffect(function () { return setGeneratingResponseIndex(null); }, [selectedId]);
    var updateSelected = function (patch) {
        if (!selected)
            return;
        setDirtyNodeIds(function (current) { return new Set(current).add(String(selected.id)); });
        setNodes(function (current) {
            return current.map(function (node) {
                return String(node.id) === String(selected.id) ? __assign(__assign({}, node), patch) : node;
            });
        });
    };
    var selectNode = function (node) {
        setSelectedId(node.id);
    };
    var addNode = function (type) {
        if (type === 'fallback_node' &&
            nodes.some(function (node) { return node.type === 'fallback_node'; })) {
            notifyFailed('Only one default fallback step is allowed.');
            return;
        }
        var node = newNode(type, nodes.length, nodes, defaultLanguageCode, defaultAiModel, { provider: '', model: '' });
        var centre = visibleCentre();
        if (centre) {
            // Stagger successive additions so they do not land exactly on top of each
            // other in the middle of the view.
            var offset = (nodes.length % 5) * 28;
            node.position_x = Math.round(centre.x - NODE_WIDTH / 2 + offset);
            node.position_y = Math.round(centre.y - NODE_HEIGHT / 2 + offset);
        }
        setNodes(function (current) { return __spreadArrays(current, [node]); });
        setDirtyNodeIds(function (current) { return new Set(current).add(String(node.id)); });
        selectNode(node);
    };
    var saveNode = function (node) {
        if (node === void 0) { node = selected; }
        return __awaiter(void 0, void 0, void 0, function () {
            var failed, nodeName, describedCollection, undescribed, intentModel, aiModel, firstIssue, knownNodeIds, nodeToSave, responses, _a, success, response, body, savedFromResponse, refreshed, refreshedNodes, savedId_1, saved_1, normalizedNodes_1, error_3;
            var _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        failed = { saved: false, nodeId: null };
                        if (!node || saving)
                            return [2 /*return*/, failed];
                        nodeName = String(node.node_name || '').trim();
                        if (!nodeName) {
                            notifyFailed('Step name is required.');
                            return [2 /*return*/, failed];
                        }
                        if (nodeName.length > NODE_NAME_MAX_LENGTH) {
                            notifyFailed("Step name must be " + NODE_NAME_MAX_LENGTH + " characters or fewer.");
                            return [2 /*return*/, failed];
                        }
                        if (nodes.some(function (item) {
                            return String(item.id) !== String(node.id) &&
                                String(item.node_name || '')
                                    .trim()
                                    .toLowerCase() === nodeName.toLowerCase();
                        })) {
                            notifyFailed("Another step is already called \u201C" + nodeName + "\u201D.");
                            return [2 /*return*/, failed];
                        }
                        describedCollection = node.type === 'intent_detection'
                            ? { items: ((_b = node.config) === null || _b === void 0 ? void 0 : _b.intents) || [], label: 'Intent' }
                            : node.type === 'capture_parameter'
                                ? { items: ((_c = node.config) === null || _c === void 0 ? void 0 : _c.parameters) || [], label: 'Parameter' }
                                : null;
                        undescribed = describedCollection === null || describedCollection === void 0 ? void 0 : describedCollection.items.find(function (item) { return !String((item === null || item === void 0 ? void 0 : item.description) || '').trim(); });
                        if (describedCollection && undescribed) {
                            notifyFailed(describedCollection.label + " \u201C" + (String(undescribed.name || '').trim() || 'unnamed') + "\u201D needs a description.");
                            return [2 /*return*/, failed];
                        }
                        if (node.type === 'intent_detection') {
                            intentModel = ((_d = node.config) === null || _d === void 0 ? void 0 : _d.intent_model) || ((_e = node.config) === null || _e === void 0 ? void 0 : _e.ai_model) || {};
                            if (!String(intentModel.provider || '').trim()) {
                                notifyFailed('Select a model provider for this step.');
                                return [2 /*return*/, failed];
                            }
                            if (!String(intentModel.model || '').trim()) {
                                notifyFailed('Select a model for this step.');
                                return [2 /*return*/, failed];
                            }
                            if (((_f = node.config) === null || _f === void 0 ? void 0 : _f.intent_model) && !String(intentModel.id || '').trim()) {
                                notifyFailed('Select a model from the available intent models.');
                                return [2 /*return*/, failed];
                            }
                        }
                        if (node.type === 'capture_parameter') {
                            aiModel = ((_g = node.config) === null || _g === void 0 ? void 0 : _g.ai_model) || {};
                            if (!String(aiModel.provider || '').trim()) {
                                notifyFailed('Select a model provider for this step.');
                                return [2 /*return*/, failed];
                            }
                            if (!String(aiModel.model || '').trim()) {
                                notifyFailed('Select a model for this step.');
                                return [2 /*return*/, failed];
                            }
                        }
                        firstIssue = nodeIssue(node, isSupportedLanguage);
                        if (firstIssue) {
                            notifyFailed(firstIssue);
                            return [2 /*return*/, failed];
                        }
                        knownNodeIds = new Set(nodes.filter(function (item) { return !item._draft; }).map(function (item) { return String(item.id); }));
                        setSaving(true);
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 6, 7, 8]);
                        nodeToSave = node;
                        if (!(node.type === 'bot_response')) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all((node.responses || []).map(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                var isDynamic, generated, generatedBody;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            isDynamic = /\{[A-Za-z_][A-Za-z0-9_]*\}/.test(response.response || '');
                                            if (isDynamic)
                                                return [2 /*return*/, __assign(__assign({}, response), { response_url: null })];
                                            if (!response.response || response.response_url)
                                                return [2 /*return*/, response];
                                            // Never spoken in a call, so no audio is generated for it.
                                            if (!isSupportedLanguage(response.language_code || 'en')) {
                                                return [2 /*return*/, response];
                                            }
                                            // Already known to be spoken live: saved without a URL, no request.
                                            if (liveTtsLanguages.has(response.language_code)) {
                                                return [2 /*return*/, __assign(__assign({}, response), { response_url: null })];
                                            }
                                            return [4 /*yield*/, api_1.generateWorkflowResponseUrl(domainId, agentId, {
                                                    response: response.response,
                                                    language_code: response.language_code,
                                                })];
                                        case 1:
                                            generated = _a.sent();
                                            if (!generated.success) {
                                                throw new Error(errorMessage(generated.response, 'Unable to generate response audio.'));
                                            }
                                            generatedBody = responseBody(generated.response);
                                            // Not a failure: Call Genie speaks a response without a URL live.
                                            if (generatedBody.live_tts) {
                                                markLiveTts(response.language_code);
                                                return [2 /*return*/, __assign(__assign({}, response), { response_url: null })];
                                            }
                                            return [2 /*return*/, __assign(__assign({}, response), { response_url: generatedBody.response_url })];
                                    }
                                });
                            }); }))];
                    case 2:
                        responses = _k.sent();
                        nodeToSave = __assign(__assign({}, node), { responses: responses });
                        _k.label = 3;
                    case 3: return [4 /*yield*/, api_1.saveWorkflowNode(domainId, agentId, cleanNode(nodeToSave))];
                    case 4:
                        _a = _k.sent(), success = _a.success, response = _a.response;
                        if (!success) {
                            throw new Error(errorMessage(response, 'Unable to save step.'));
                        }
                        body = responseBody(response);
                        savedFromResponse = body.node || (body.id ? body : null);
                        return [4 /*yield*/, api_1.getWorkflowNodes(domainId, agentId)];
                    case 5:
                        refreshed = _k.sent();
                        if (!refreshed.success) {
                            throw new Error(errorMessage(refreshed.response, 'Step saved, but the workflow could not be refreshed.'));
                        }
                        refreshedNodes = responseBody(refreshed.response).nodes || [];
                        savedId_1 = (_h = savedFromResponse === null || savedFromResponse === void 0 ? void 0 : savedFromResponse.id) !== null && _h !== void 0 ? _h : (!node._draft ? node.id : null);
                        saved_1 = refreshedNodes.find(function (item) { return savedId_1 !== null && String(item.id) === String(savedId_1); }) ||
                            (node._draft
                                ? refreshedNodes.find(function (item) { return !knownNodeIds.has(String(item.id)); })
                                : undefined);
                        normalizedNodes_1 = refreshedNodes.map(withPersistedSnapshot);
                        setNodes(function (current) {
                            var merged = normalizedNodes_1.map(function (serverNode) {
                                if (String(serverNode.id) === String(saved_1 === null || saved_1 === void 0 ? void 0 : saved_1.id))
                                    return serverNode;
                                var localNode = current.find(function (item) { return String(item.id) === String(serverNode.id); });
                                return localNode && dirtyNodeIds.has(String(localNode.id))
                                    ? __assign(__assign({}, localNode), { _persisted: serverNode._persisted }) : serverNode;
                            });
                            var otherDrafts = current.filter(function (item) { return item._draft && String(item.id) !== String(node.id); });
                            return __spreadArrays(merged, otherDrafts);
                        });
                        setSelectedId((saved_1 === null || saved_1 === void 0 ? void 0 : saved_1.id) || null);
                        setDirtyNodeIds(function (current) {
                            var next = new Set(current);
                            next["delete"](String(node.id));
                            if (saved_1 === null || saved_1 === void 0 ? void 0 : saved_1.id)
                                next["delete"](String(saved_1.id));
                            return next;
                        });
                        notifyDone('Step saved.');
                        return [2 /*return*/, { saved: true, nodeId: (_j = saved_1 === null || saved_1 === void 0 ? void 0 : saved_1.id) !== null && _j !== void 0 ? _j : null }];
                    case 6:
                        error_3 = _k.sent();
                        notifyFailed(thrownMessage(error_3, 'Unable to save step.'));
                        return [2 /*return*/, failed];
                    case 7:
                        setSaving(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    var pickDraftAcknowledgement = function (toolNode, draft) {
        // Not a destructive action, so this is the plain confirmation style
        // rather than the red one confirmAction uses.
        BotActions_1.showConfirmationDialog({
            title: 'Save the Bot Response step first?',
            message: "\u201C" + draft.node_name + "\u201D has not been saved yet. It will be saved now so this step can use it as its processing message.",
            okTitle: 'Save and use',
            cancelTitle: 'Cancel',
            onCancel: function () { },
            onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, saved, nodeId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, saveNode(draft)];
                        case 1:
                            _a = _b.sent(), saved = _a.saved, nodeId = _a.nodeId;
                            if (!saved || nodeId === null)
                                return [2 /*return*/];
                            // Saving selects the response step; point the tool step at it and
                            // reopen the tool step, which keeps its other unsaved edits.
                            setNodes(function (current) {
                                return current.map(function (node) {
                                    return String(node.id) === String(toolNode.id)
                                        ? __assign(__assign({}, node), { config: __assign(__assign({}, node.config), { acknowledgement_config: {
                                                    type: 'custom',
                                                    response_node_id: Number(nodeId),
                                                } }) }) : node;
                                });
                            });
                            setDirtyNodeIds(function (current) { return new Set(current).add(String(toolNode.id)); });
                            setSelectedId(toolNode.id);
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    };
    var moveNode = function (node, positionX, positionY) { return __awaiter(void 0, void 0, void 0, function () {
        var moved, revertPosition, persistedMove, success, response, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    moved = __assign(__assign({}, node), { position_x: Math.round(positionX), position_y: Math.round(positionY) });
                    setNodes(function (current) {
                        return current.map(function (item) {
                            return String(item.id) === String(node.id) ? moved : item;
                        });
                    });
                    if (node._draft)
                        return [2 /*return*/];
                    revertPosition = function () {
                        return setNodes(function (current) {
                            return current.map(function (item) {
                                return String(item.id) === String(node.id)
                                    ? __assign(__assign({}, item), { position_x: Number(node.position_x || 0), position_y: Number(node.position_y || 0) }) : item;
                            });
                        });
                    };
                    persistedMove = __assign(__assign({}, (node._persisted || node)), { position_x: moved.position_x, position_y: moved.position_y });
                    success = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.saveWorkflowNode(domainId, agentId, cleanNode(persistedMove))];
                case 2:
                    (_a = _b.sent(), success = _a.success, response = _a.response);
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _b.sent();
                    revertPosition();
                    notifyFailed(thrownMessage(error_4, 'Unable to save position.'));
                    return [2 /*return*/];
                case 4:
                    if (!success) {
                        revertPosition();
                        notifyFailed(errorMessage(response, 'Unable to save position.'));
                        return [2 /*return*/];
                    }
                    setNodes(function (current) {
                        return current.map(function (item) {
                            return String(item.id) === String(node.id)
                                ? __assign(__assign({}, item), { _persisted: __assign(__assign({}, (item._persisted || node._persisted || node)), { position_x: moved.position_x, position_y: moved.position_y }) }) : item;
                        });
                    });
                    setStatus('');
                    return [2 /*return*/];
            }
        });
    }); };
    // Moves a step by dragging. Used by the closed card and by the header of
    // the open step's editor, which follows the step's position, so a step
    // can be grabbed and moved whether it is open or closed.
    var beginNodeDrag = function (event, node) {
        var target = event.target;
        if (event.button !== 0 ||
            target.closest('button,input,select,textarea,.workflow-node-route'))
            return;
        var card = event.currentTarget;
        var startX = event.clientX;
        var startY = event.clientY;
        var originX = Number(node.position_x || 0);
        var originY = Number(node.position_y || 0);
        var moved = false;
        var frame = null;
        var latestX = originX;
        var latestY = originY;
        card.setPointerCapture(event.pointerId);
        // Drive the drag through state rather than mutating the card
        // directly, so the SVG connections re-render with the node
        // instead of snapping into place on release. One update per
        // animation frame keeps that affordable.
        var onMove = function (moveEvent) {
            latestX = originX + (moveEvent.clientX - startX) / zoom;
            latestY = originY + (moveEvent.clientY - startY) / zoom;
            if (!moved && (latestX !== originX || latestY !== originY)) {
                moved = true;
                // Closed hand only once the card actually moves, so a
                // plain click to open the step doesn't flash it.
                card.classList.add('workflow-node-dragging');
            }
            if (frame !== null)
                return;
            frame = requestAnimationFrame(function () {
                frame = null;
                setNodes(function (current) {
                    return current.map(function (item) {
                        return String(item.id) === String(node.id)
                            ? __assign(__assign({}, item), { position_x: latestX, position_y: latestY }) : item;
                    });
                });
            });
        };
        var onUp = function (upEvent) {
            card.removeEventListener('pointermove', onMove);
            card.removeEventListener('pointerup', onUp);
            card.releasePointerCapture(upEvent.pointerId);
            card.classList.remove('workflow-node-dragging');
            if (frame !== null) {
                cancelAnimationFrame(frame);
                frame = null;
            }
            if (!moved)
                return;
            // Only the closed card opens its step on click, so only a card drag
            // must swallow the click that ends it. An editor-header drag leaves it
            // alone, or the next click on any card would be ignored.
            if (card.classList.contains('workflow-node-card')) {
                dragJustEndedRef.current = true;
            }
            moveNode(node, originX + (upEvent.clientX - startX) / zoom, originY + (upEvent.clientY - startY) / zoom);
        };
        card.addEventListener('pointermove', onMove);
        card.addEventListener('pointerup', onUp);
    };
    var deleteNode = function (removed) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!removed._draft) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.deleteWorkflowNode(domainId, agentId, removed.id)];
                case 2:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (!success) {
                        notifyFailed(errorMessage(response, 'Unable to delete step.'));
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _b.sent();
                    notifyFailed(thrownMessage(error_5, 'Unable to delete step.'));
                    return [2 /*return*/];
                case 4:
                    setNodes(function (current) {
                        return current
                            .filter(function (node) { return String(node.id) !== String(removed.id); })
                            .map(function (node) { return (__assign(__assign({}, node), { destinations: (node.destinations || []).filter(function (destination) {
                                return String(destination.target_node_id) !== String(removed.id);
                            }), _persisted: node._persisted
                                ? __assign(__assign({}, node._persisted), { destinations: (node._persisted.destinations || []).filter(function (destination) {
                                        return String(destination.target_node_id) !== String(removed.id);
                                    }) }) : node._persisted })); });
                    });
                    setSelectedId(null);
                    setDirtyNodeIds(function (current) {
                        var next = new Set(current);
                        next["delete"](String(removed.id));
                        return next;
                    });
                    notifyDone('Step deleted.');
                    return [2 /*return*/];
            }
        });
    }); };
    var removeNode = function () {
        if (!selected)
            return;
        var node = selected;
        // The backend refuses to delete the saved entry step while other saved
        // steps remain, so say why up front instead of after a confirmation.
        var savedAsEntry = Boolean((node._persisted || node).is_entry);
        var hasOtherSavedSteps = nodes.some(function (other) { return !other._draft && String(other.id) !== String(node.id); });
        if (!node._draft && savedAsEntry && hasOtherSavedSteps) {
            notifyFailed('This is the entry step. Mark another step as the entry step before deleting it.');
            return;
        }
        confirmAction({
            title: "Delete \u201C" + node.node_name + "\u201D?",
            message: node._draft
                ? 'This step has not been saved yet and will be discarded.'
                : 'Connections to this step will be removed too. This action cannot be undone.',
            okTitle: 'Delete',
            onOk: function () {
                deleteNode(node);
            },
        });
    };
    var setEntry = function (checked) {
        if (!selected)
            return;
        setDirtyNodeIds(function (current) { return new Set(current).add(String(selected.id)); });
        setNodes(function (current) {
            return current.map(function (node) { return (__assign(__assign({}, node), { is_entry: String(node.id) === String(selected.id)
                    ? checked
                    : checked
                        ? false
                        : node.is_entry })); });
        });
    };
    var routeKeys = function (node) {
        var _a, _b;
        if (node.type === 'bot_response') {
            return [
                {
                    key: 'main',
                    label: routeActionFor(node) === 'immediate'
                        ? 'Continue immediately'
                        : 'User reply',
                },
            ];
        }
        if (node.type === 'intent_detection') {
            return __spreadArrays((((_a = node.config) === null || _a === void 0 ? void 0 : _a.intents) || []).map(function (intent) { return ({
                key: intent.name,
                label: intent.name,
            }); }), [
                { key: 'other', label: 'Other' },
            ]);
        }
        if (node.type === 'capture_parameter') {
            // The backend allows one unconditional destination instead of the two
            // outcome routes, and forbids mixing them. Surface whichever form the
            // node actually uses so an imported workflow stays editable.
            var hasUnconditional = (node.destinations || []).some(function (destination) { return destination.on_capture === undefined; });
            return hasUnconditional
                ? [
                    {
                        key: 'always',
                        label: 'Always (unconditional)',
                        shortLabel: 'Always',
                    },
                ]
                : [
                    {
                        key: 'all_required_params_collected',
                        label: 'All required parameters collected',
                        shortLabel: 'All collected',
                    },
                    {
                        key: 'no_params_updated',
                        label: 'No parameters updated',
                        shortLabel: 'None updated',
                    },
                ];
        }
        if (node.type === 'condition') {
            return [
                { key: 'true', label: 'True' },
                { key: 'false', label: 'False' },
            ];
        }
        var linkedTool = tools.find(function (tool) { return String(tool.id) === String(node.tool_id); });
        var mode = ((_b = node.tool_definition) === null || _b === void 0 ? void 0 : _b.mode) || (linkedTool === null || linkedTool === void 0 ? void 0 : linkedTool.mode);
        return mode === 'handoff' || node.type === 'fallback_node'
            ? []
            : [{ key: 'main', label: 'Next step' }];
    };
    var destinationFor = function (node, key) {
        var _a, _b, _c, _d, _e;
        if (key === 'main')
            return (_a = node.destinations) === null || _a === void 0 ? void 0 : _a[0];
        if (node.type === 'intent_detection') {
            return (_b = node.destinations) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.on_intent === key; });
        }
        if (node.type === 'capture_parameter') {
            return key === 'always'
                ? (_c = node.destinations) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.on_capture === undefined; }) : (_d = node.destinations) === null || _d === void 0 ? void 0 : _d.find(function (item) { return item.on_capture === key; });
        }
        return (_e = node.destinations) === null || _e === void 0 ? void 0 : _e.find(function (item) { return item.on_condition === (key === 'true'); });
    };
    var routeKeyForDestination = function (node, destination) {
        if (node.type === 'intent_detection')
            return destination.on_intent;
        if (node.type === 'capture_parameter')
            return destination.on_capture === undefined
                ? 'always'
                : destination.on_capture;
        if (node.type === 'condition')
            return String(destination.on_condition);
        return 'main';
    };
    var updateNodeRoute = function (source, key, target) { return __awaiter(void 0, void 0, void 0, function () {
        var previousDestinations, destinations, targetNodeId, clearShape, reshape, persisted, revertDestinations, success, response, error_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (target && String(source.id) === String(target)) {
                        notifyFailed('A step cannot connect to itself.');
                        return [2 /*return*/];
                    }
                    previousDestinations = __spreadArrays((source.destinations || []));
                    destinations = __spreadArrays(previousDestinations);
                    if (key === 'main')
                        destinations = [];
                    else if (source.type === 'intent_detection') {
                        destinations = destinations.filter(function (item) { return item.on_intent !== key; });
                    }
                    else if (source.type === 'capture_parameter') {
                        // An unconditional route replaces the outcome routes entirely.
                        destinations =
                            key === 'always'
                                ? []
                                : destinations.filter(function (item) { return item.on_capture !== key; });
                    }
                    else {
                        destinations = destinations.filter(function (item) { return item.on_condition !== (key === 'true'); });
                    }
                    if (target) {
                        targetNodeId = Number(target);
                        if (key === 'main') {
                            destinations.push(source.type === 'bot_response'
                                ? {
                                    on_action: routeActionFor(source),
                                    target_node_id: targetNodeId,
                                }
                                : { target_node_id: targetNodeId });
                        }
                        else if (source.type === 'intent_detection') {
                            destinations.push({ on_intent: key, target_node_id: targetNodeId });
                        }
                        else if (source.type === 'capture_parameter') {
                            destinations.push(key === 'always'
                                ? { target_node_id: targetNodeId }
                                : { on_capture: key, target_node_id: targetNodeId });
                        }
                        else {
                            destinations.push({
                                on_condition: key === 'true',
                                target_node_id: targetNodeId,
                            });
                        }
                    }
                    clearShape = !target && Boolean(edgePointFor(source, key));
                    reshape = function (node) {
                        return clearShape ? withEdgePoint(node, key, null) : node;
                    };
                    setNodes(function (current) {
                        return current.map(function (node) {
                            return String(node.id) === String(source.id)
                                ? reshape(__assign(__assign({}, node), { destinations: destinations }))
                                : node;
                        });
                    });
                    if (!source._draft) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveNode(reshape(__assign(__assign({}, source), { destinations: destinations })))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
                case 2:
                    persisted = reshape(__assign(__assign({}, (source._persisted || source)), { destinations: destinations }));
                    revertDestinations = function () {
                        return setNodes(function (current) {
                            return current.map(function (node) {
                                return String(node.id) === String(source.id)
                                    ? __assign(__assign({}, node), { destinations: previousDestinations }) : node;
                            });
                        });
                    };
                    success = false;
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, api_1.saveWorkflowNode(domainId, agentId, cleanNode(persisted))];
                case 4:
                    (_a = _b.sent(), success = _a.success, response = _a.response);
                    return [3 /*break*/, 6];
                case 5:
                    error_6 = _b.sent();
                    revertDestinations();
                    notifyFailed(thrownMessage(error_6, 'Unable to save connection.'));
                    return [2 /*return*/];
                case 6:
                    if (!success) {
                        revertDestinations();
                        notifyFailed(errorMessage(response, 'Unable to save connection.'));
                        return [2 /*return*/];
                    }
                    setNodes(function (current) {
                        return current.map(function (node) {
                            return String(node.id) === String(source.id)
                                ? __assign(__assign({}, node), { _persisted: __assign(__assign({}, (node._persisted || source._persisted || source)), { destinations: destinations }) }) : node;
                        });
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    // Removing a connection is saved straight away, so it is confirmed first.
    var confirmDeleteConnection = function (source, key) {
        var target = nodes.find(function (node) { var _a; return String(node.id) === String((_a = destinationFor(source, key)) === null || _a === void 0 ? void 0 : _a.target_node_id); });
        confirmAction({
            title: 'Delete this connection?',
            message: "\u201C" + source.node_name + "\u201D will no longer go to \u201C" + ((target === null || target === void 0 ? void 0 : target.node_name) || 'its next step') + "\u201D.",
            okTitle: 'Delete',
            onOk: function () {
                updateNodeRoute(source, key, '');
            },
        });
    };
    var updateRoute = function (key, target) {
        if (!selected)
            return;
        // Picking "No next step" over an existing route deletes that connection.
        if (!target && destinationFor(selected, key)) {
            confirmDeleteConnection(selected, key);
            return;
        }
        updateNodeRoute(selected, key, target);
    };
    var setEdgePointLocally = function (source, key, point) {
        return setNodes(function (current) {
            return current.map(function (item) {
                return String(item.id) === String(source.id)
                    ? withEdgePoint(item, key, point)
                    : item;
            });
        });
    };
    var saveEdgePoint = function (source, key, point) { return __awaiter(void 0, void 0, void 0, function () {
        var previous, persisted, success, response, error_7;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    previous = edgePointFor(source, key);
                    setEdgePointLocally(source, key, point);
                    // A draft has nothing on the server yet; the shape rides along on its
                    // first save like the rest of the node.
                    if (source._draft)
                        return [2 /*return*/];
                    persisted = withEdgePoint(source._persisted || source, key, point);
                    success = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.saveWorkflowNode(domainId, agentId, cleanNode(persisted))];
                case 2:
                    (_a = _b.sent(), success = _a.success, response = _a.response);
                    return [3 /*break*/, 4];
                case 3:
                    error_7 = _b.sent();
                    setEdgePointLocally(source, key, previous);
                    notifyFailed(thrownMessage(error_7, 'Unable to save the connection shape.'));
                    return [2 /*return*/];
                case 4:
                    if (!success) {
                        setEdgePointLocally(source, key, previous);
                        notifyFailed(errorMessage(response, 'Unable to save the connection shape.'));
                        return [2 /*return*/];
                    }
                    setNodes(function (current) {
                        return current.map(function (item) {
                            return String(item.id) === String(source.id)
                                ? __assign(__assign({}, item), { _persisted: persisted }) : item;
                        });
                    });
                    setStatus(point ? 'Connection shape saved.' : 'Connection shape reset.');
                    return [2 /*return*/];
            }
        });
    }); };
    var startEdgePointDrag = function (event, source, key) {
        event.preventDefault();
        event.stopPropagation();
        var frame = null;
        var latest = null;
        var onMove = function (moveEvent) {
            var point = canvasPointFrom(moveEvent.clientX, moveEvent.clientY);
            if (!point)
                return;
            latest = { x: Math.round(point.x), y: Math.round(point.y) };
            if (frame !== null)
                return;
            frame = requestAnimationFrame(function () {
                frame = null;
                if (latest)
                    setEdgePointLocally(source, key, latest);
            });
        };
        var onUp = function () {
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            if (frame !== null) {
                cancelAnimationFrame(frame);
                frame = null;
            }
            if (latest)
                saveEdgePoint(source, key, latest);
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
    };
    var startConnectionDrag = function (event, source, key) {
        event.preventDefault();
        event.stopPropagation();
        var startClientX = event.clientX;
        var startClientY = event.clientY;
        setConnecting({ sourceId: source.id, key: key });
        setConnectionPoint(canvasPointFrom(event.clientX, event.clientY));
        var onMove = function (moveEvent) {
            setConnectionPoint(canvasPointFrom(moveEvent.clientX, moveEvent.clientY));
        };
        var onUp = function (upEvent) {
            var _a;
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            var moved = Math.hypot(upEvent.clientX - startClientX, upEvent.clientY - startClientY) > 5;
            var targetElement = (_a = document
                .elementFromPoint(upEvent.clientX, upEvent.clientY)) === null || _a === void 0 ? void 0 : _a.closest('.workflow-node-card, .workflow-node-editor');
            var targetId = targetElement === null || targetElement === void 0 ? void 0 : targetElement.dataset.nodeId;
            var target = nodes.find(function (node) { return String(node.id) === targetId; });
            setConnectionPoint(null);
            if (target && !target._draft && String(target.id) !== String(source.id)) {
                connectionJustDroppedRef.current = true;
                updateNodeRoute(source, key, String(target.id));
                setConnecting(null);
            }
            else if (moved) {
                setConnecting(null);
                setStatus((target === null || target === void 0 ? void 0 : target._draft) ? 'Save the destination step before connecting it.'
                    : 'Connection cancelled.');
            }
            else {
                setStatus('Select a destination step, or drag the connector onto it.');
            }
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
    };
    // A handoff gives the turn to another agent, so the backend rejects any
    // destination on the node. The route picker disappears with the handoff mode,
    // so a leftover route has to be dropped here or it becomes unreachable while
    // still failing the save.
    var withHandoffRoutesCleared = function (patch, mode) {
        var _a;
        return mode === 'handoff' && ((_a = selected === null || selected === void 0 ? void 0 : selected.destinations) === null || _a === void 0 ? void 0 : _a.length)
            ? __assign(__assign({}, patch), { destinations: [] }) : patch;
    };
    var updateToolDefinition = function (patch) {
        if (!selected)
            return;
        var toolDefinition = __assign(__assign({ name: selected.node_name, description: '', mode: 'tool_call', parameters: VoiceAgentLayoutUtils_1.DEFAULT_TOOL_PARAMETERS, code: '' }, (selected.tool_definition || {})), patch);
        updateSelected(withHandoffRoutesCleared({ tool_definition: toolDefinition }, toolDefinition.mode));
    };
    var updateResponse = function (index, field, value) {
        var _a;
        if (!selected)
            return;
        var responses = __spreadArrays((selected.responses || []));
        responses[index] = __assign(__assign(__assign({}, responses[index]), (_a = {}, _a[field] = value, _a)), (field === 'response' ? { response_url: null } : {}));
        updateSelected({ responses: responses });
    };
    var generateResponseAudio = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, resultBody, responseUrl_1, error_8;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!selected)
                        return [2 /*return*/, null];
                    response = (_a = selected.responses) === null || _a === void 0 ? void 0 : _a[index];
                    if (!((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.trim())) {
                        notifyFailed('Enter response text before generating audio.');
                        return [2 /*return*/, null];
                    }
                    if (/\{[A-Za-z_][A-Za-z0-9_]*\}/.test(response.response)) {
                        updateResponse(index, 'response_url', '');
                        setStatus('Dynamic responses use live TTS and do not need an audio URL.');
                        return [2 /*return*/, null];
                    }
                    setGeneratingResponseIndex(index);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api_1.generateWorkflowResponseUrl(domainId, agentId, {
                            response: response.response,
                            language_code: response.language_code,
                        })];
                case 2:
                    result = _c.sent();
                    if (!result.success) {
                        throw new Error(errorMessage(result.response, 'Unable to generate response audio.'));
                    }
                    resultBody = responseBody(result.response);
                    if (resultBody.live_tts) {
                        markLiveTts(response.language_code);
                        setStatus(LIVE_TTS_HINT);
                        return [2 /*return*/, null];
                    }
                    responseUrl_1 = String(resultBody.response_url || '').trim();
                    if (!responseUrl_1) {
                        throw new Error('Audio generation completed without a response URL.');
                    }
                    setNodes(function (current) {
                        return current.map(function (node) {
                            if (String(node.id) !== String(selected.id))
                                return node;
                            var responses = __spreadArrays((node.responses || []));
                            if (!responses[index])
                                return node;
                            responses[index] = __assign(__assign({}, responses[index]), { response_url: responseUrl_1, _audio_source: responses[index].response });
                            return __assign(__assign({}, node), { responses: responses });
                        });
                    });
                    setDirtyNodeIds(function (current) { return new Set(current).add(String(selected.id)); });
                    notifyDone('Response audio generated. Save the step to persist it.');
                    return [2 /*return*/, responseUrl_1];
                case 3:
                    error_8 = _c.sent();
                    notifyFailed(thrownMessage(error_8, 'Unable to generate response audio.'));
                    return [2 /*return*/, null];
                case 4:
                    setGeneratingResponseIndex(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Plays one variation's audio in the preview player, replacing whatever
    // was playing. `afterGenerate` marks the automatic play that follows a
    // Generate: by then the browser may refuse to start audio on its own, which
    // is not a failure, so it only points the user to the Play button.
    var startPreview = function (url, index, afterGenerate) {
        if (afterGenerate === void 0) { afterGenerate = false; }
        if (previewAudioRef.current)
            previewAudioRef.current.pause();
        var audio = new Audio(url);
        audio.preload = 'auto';
        previewAudioRef.current = audio;
        setPlayingResponseIndex(index);
        audio.addEventListener('ended', function () {
            if (previewAudioRef.current !== audio)
                return;
            previewAudioRef.current = null;
            setPlayingResponseIndex(null);
        }, { once: true });
        audio.play()["catch"](function () {
            if (previewAudioRef.current !== audio)
                return;
            previewAudioRef.current = null;
            setPlayingResponseIndex(null);
            if (afterGenerate) {
                setStatus('Audio generated. Press play to listen to it.');
            }
            else {
                notifyFailed('Unable to play response audio.');
            }
        });
    };
    // Why a variation's Play button is disabled, or null when it can play.
    // Play is greyed out only while audio is being generated; otherwise it
    // plays the existing clip, or generates one first when there is none.
    var playDisabledReason = function (response, index) {
        // A clip that is playing can always be paused.
        if (playingResponseIndex === index)
            return null;
        if (generatingResponseIndex === index)
            return 'Generating audio…';
        // Only one generation runs at a time, so a variation that would have to
        // generate waits for the one in progress; one with a clip can still play.
        if (generatingResponseIndex !== null && !response.response_url) {
            return 'Another variation is generating audio…';
        }
        if (audioRegenerationInProgress) {
            return 'Audio is being regenerated for the new voice. Play is available once it finishes.';
        }
        return null;
    };
    // Generate / Regenerate plays the new audio as soon as it is ready, so the
    // user hears the result without a second click.
    var generateAndPlayResponseAudio = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var stepId, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stepId = selectedIdRef.current;
                    return [4 /*yield*/, generateResponseAudio(index)];
                case 1:
                    url = _a.sent();
                    if (!url)
                        return [2 /*return*/];
                    // Switching steps mid-generation stops previews for the old step; do not
                    // start one for a step that is no longer on screen.
                    if (String(selectedIdRef.current) !== String(stepId))
                        return [2 /*return*/];
                    startPreview(url, index, true);
                    return [2 /*return*/];
            }
        });
    }); };
    // Play the clip if it matches the current text. Editing the text clears the
    // clip, so a new or edited variation generates first and then plays, the
    // same as pressing Generate / Regenerate.
    var playResponseAudio = function (response, index) {
        if (previewAudioRef.current && playingResponseIndex === index) {
            stopPreviewAudio();
            return;
        }
        if (playDisabledReason(response, index))
            return;
        if (response.response_url) {
            startPreview(response.response_url, index);
            return;
        }
        generateAndPlayResponseAudio(index);
    };
    var updateConfigItem = function (collection, index, patch) {
        var _a;
        var _b, _c, _d;
        if (!selected)
            return;
        var items = __spreadArrays((((_b = selected.config) === null || _b === void 0 ? void 0 : _b[collection]) || []));
        var previousName = (_c = items[index]) === null || _c === void 0 ? void 0 : _c.name;
        items[index] = __assign(__assign({}, items[index]), patch);
        var patched = {
            config: __assign(__assign({}, selected.config), (_a = {}, _a[collection] = items, _a)),
        };
        // Intent destinations are keyed by intent name, so a rename has to move the
        // route with it or the edge is orphaned and renders under the stale label.
        if (collection === 'intents' &&
            'name' in patch &&
            previousName &&
            patch.name !== previousName) {
            patched.destinations = (selected.destinations || []).map(function (destination) {
                return destination.on_intent === previousName
                    ? __assign(__assign({}, destination), { on_intent: patch.name }) : destination;
            });
            var shapes = __assign({}, (((_d = selected.metadata) === null || _d === void 0 ? void 0 : _d.edge_points) || {}));
            if (shapes[previousName]) {
                shapes[patch.name] = shapes[previousName];
                delete shapes[previousName];
                patched.metadata = __assign(__assign({}, (selected.metadata || {})), { edge_points: shapes });
            }
        }
        updateSelected(patched);
    };
    var addConfigItem = function (collection, item) {
        var _a;
        var _b;
        if (!selected)
            return;
        updateSelected({
            config: __assign(__assign({}, selected.config), (_a = {}, _a[collection] = __spreadArrays((((_b = selected.config) === null || _b === void 0 ? void 0 : _b[collection]) || []), [item]), _a)),
        });
    };
    var removeConfigItem = function (collection, index) {
        var _a;
        var _b;
        if (!selected)
            return;
        var items = __spreadArrays((((_b = selected.config) === null || _b === void 0 ? void 0 : _b[collection]) || []));
        var removed = items.splice(index, 1)[0];
        var destinations = selected.destinations || [];
        if (collection === 'intents' && (removed === null || removed === void 0 ? void 0 : removed.name)) {
            destinations = destinations.filter(function (destination) { return destination.on_intent !== removed.name; });
        }
        updateSelected({
            config: __assign(__assign({}, selected.config), (_a = {}, _a[collection] = items, _a)),
            destinations: destinations,
        });
    };
    var applyToolParameters = function () {
        try {
            updateToolDefinition({ parameters: JSON.parse(toolParameters || '{}') });
            notifyDone('Tool parameters applied. Save the step to persist them.');
        }
        catch (_) {
            notifyFailed('Parameters must be valid JSON Schema.');
        }
    };
    var updateToolParameter = function (oldName, nextName, patch, required) {
        var _a, _b;
        var schema = ((_a = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) || {};
        var existing = Object.entries(schema.properties || {});
        var definition = __assign(__assign({}, (((_b = schema.properties) === null || _b === void 0 ? void 0 : _b[oldName]) || {})), patch);
        // Rebuild in place rather than delete-then-append: moving the key to the end
        // reorders the rendered list and tears down the input being typed into.
        var properties = Object.fromEntries(existing.some(function (_a) {
            var key = _a[0];
            return key === oldName;
        })
            ? existing.map(function (_a) {
                var key = _a[0], value = _a[1];
                return key === oldName ? [nextName, definition] : [key, value];
            })
            : __spreadArrays(existing, [[nextName, definition]]));
        var requiredNames = (schema.required || []).filter(function (name) { return name !== oldName; });
        if (required)
            requiredNames.push(nextName);
        var parameters = __assign(__assign({ type: 'object' }, schema), { properties: properties, required: requiredNames, additionalProperties: false });
        setToolParameters(JSON.stringify(parameters, null, 2));
        updateToolDefinition({ parameters: parameters });
    };
    var removeToolParameter = function (name) {
        var _a;
        var schema = ((_a = selected === null || selected === void 0 ? void 0 : selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) || {};
        var properties = __assign({}, (schema.properties || {}));
        delete properties[name];
        var parameters = __assign(__assign({}, schema), { properties: properties, required: (schema.required || []).filter(function (item) { return item !== name; }) });
        setToolParameters(JSON.stringify(parameters, null, 2));
        updateToolDefinition({ parameters: parameters });
    };
    // The scroll area has to reach wherever the graph actually goes, and must not
    // depend on which step is selected or it would resize on every selection.
    var canvasExtent = nodes.reduce(function (bounds, node) {
        var _a;
        var points = Object.values(((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.edge_points) || {});
        return {
            right: Math.max.apply(Math, __spreadArrays([bounds.right,
                Number(node.position_x || 0) + EDITOR_PANEL_WIDTH], points.map(function (point) { return Number((point === null || point === void 0 ? void 0 : point.x) || 0); }))),
            bottom: Math.max.apply(Math, __spreadArrays([bounds.bottom,
                Number(node.position_y || 0) + NODE_HEIGHT], points.map(function (point) { return Number((point === null || point === void 0 ? void 0 : point.y) || 0); }))),
        };
    }, { right: 0, bottom: 0 });
    var canvasContentWidth = Math.max(MIN_CANVAS_WIDTH, Math.round(canvasExtent.right + CANVAS_MARGIN));
    var canvasContentHeight = Math.max(MIN_CANVAS_HEIGHT, Math.round(canvasExtent.bottom + CANVAS_MARGIN));
    // The step editor is drawn at full size whatever the zoom, so it stays
    // readable at 25% and fits the screen at 300%. The hidden card under it is
    // sized to match on screen, so connections still leave from its right edge.
    var selectedCardWidth = EDITOR_PANEL_WIDTH / zoom;
    // The editor follows its step, but is kept inside the visible canvas with
    // room for its footer; anything taller scrolls inside the editor itself.
    var canvasViewHeight = ((_j = canvasRef.current) === null || _j === void 0 ? void 0 : _j.clientHeight) || 800;
    var editorTop = Math.min(Math.max(EDITOR_EDGE_GAP, toScrollY(Number((selected === null || selected === void 0 ? void 0 : selected.position_y) || 0)) - canvasScroll.top), Math.max(EDITOR_EDGE_GAP, canvasViewHeight - EDITOR_MIN_HEIGHT - EDITOR_EDGE_GAP));
    var editorMaxHeight = Math.max(EDITOR_MIN_HEIGHT, canvasViewHeight - editorTop - EDITOR_EDGE_GAP);
    return (react_1["default"].createElement("div", { ref: rootRef, className: "workflow-native-builder" + (isPanning ? ' workflow-panning' : spaceHeld ? ' workflow-space-pan' : ''), style: {
            // Stays in the page's content area so the app's own navigation keeps its
            // space; the shell's padding is stripped below instead of being escaped.
            position: 'relative',
            width: '100%',
            height: "calc(100vh - " + APP_HEADER_HEIGHT + "px)",
            minHeight: 0,
            maxHeight: "calc(100vh - " + APP_HEADER_HEIGHT + "px)",
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            background: '#f8f9fc',
        } },
        react_1["default"].createElement("style", null, "\n        @keyframes workflow-spin { to { transform: rotate(360deg); } }\n        .workflow-native-builder, .workflow-native-builder * { box-sizing: border-box; }\n        .workflow-native-builder button { font: inherit; }\n        .workflow-node-editor { color: #111a38; }\n        .workflow-node-editor label { display: block; margin: 12px 0 5px; color: #344054; font-size: 12px; font-weight: 700; }\n        .workflow-node-editor label > select,\n        .workflow-node-editor select,\n        .workflow-node-editor input[type='number'] { width: 100%; min-height: 38px; padding: 8px 10px; border: 1px solid #d8dee8; border-radius: 8px; background: #fff; color: #111a38; }\n        .workflow-node-editor input[type='range'] { width: 100%; margin-top: 8px; }\n        .workflow-node-editor input[type='checkbox'] { width: auto; margin-right: 5px; }\n        .workflow-node-editor textarea { resize: vertical; }\n        .workflow-node-editor .workflow-editor-actions { position: sticky; bottom: 0; z-index: 2; margin: 18px -16px 0; padding: 12px 16px; border-top: 1px solid #e3e7ef; background: rgba(255,255,255,.97); }\n        .workflow-node-card[data-selected='true'] { z-index: 19; visibility: hidden; }\n        .workflow-panning main, .workflow-panning main * { cursor: grabbing !important; }\n        .workflow-node-dragging, .workflow-node-dragging * { cursor: grabbing !important; }\n        .workflow-space-pan main, .workflow-space-pan main * { cursor: grab !important; }\n        .workflow-node-card[data-selected='true'] .workflow-node-route { display: none !important; }\n        .workflow-node-route > span { display: block; min-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 600; }\n        .workflow-edge-handle { opacity: 0; transition: opacity .12s ease; }\n        .workflow-edge:hover .workflow-edge-handle,\n        .workflow-edge-handle[data-active='true'] { opacity: 1; }\n        .workflow-connection-menu button { border: 0; border-radius: 7px; background: #fff; color: #344054; text-align: left; }\n        .workflow-connection-menu button:hover { background: #f2f4f7; }\n        .workflow-palette-button { position: relative; width: 100%; min-height: 66px; margin-top: 10px; padding: 9px 12px 9px 16px; display: flex; align-items: center; gap: 11px; border: 1px solid #d8dee8; border-radius: 8px; color: #111a38; background: #fff; cursor: grab; text-align: left; transition: border-color .16s ease, box-shadow .16s ease, background .16s ease; }\n        .workflow-palette-button:active { cursor: grabbing; }\n        .workflow-palette-icon, .workflow-palette-grip { width: 38px; height: 38px; flex: 0 0 auto; place-items: center; border-radius: 10px; font-size: 20px; }\n        .workflow-palette-icon { display: grid; }\n        .workflow-palette-grip { display: none; color: currentColor; }\n        .workflow-palette-label { min-width: 0; flex: 1; font-size: 14px; font-weight: 700; }\n        .workflow-palette-arrow { display: none; color: currentColor; font-size: 27px; line-height: 1; }\n        .workflow-palette-button:not(:disabled):hover { border-color: var(--workflow-step-color); background: #f8ffff; box-shadow: 0 0 0 1px var(--workflow-step-color); }\n        .workflow-palette-button:not(:disabled):hover .workflow-palette-icon { display: none; }\n        .workflow-palette-button:not(:disabled):hover .workflow-palette-grip { display: grid; color: var(--workflow-step-color); }\n        .workflow-palette-button:not(:disabled):hover .workflow-palette-arrow { display: block; color: var(--workflow-step-color); }\n        .workflow-palette-button:disabled { opacity: .58; cursor: not-allowed; background: #f2f4f7; border-color: #d0d5dd; color: #667085; }\n        .workflow-fallback-added { display: block; margin-top: 2px; color: #b54708; font-size: 11px; font-weight: 600; }\n        .workflow-palette-help { margin-top: auto; padding: 20px 4px 4px; display: flex; align-items: flex-start; gap: 9px; color: #8290a9; font-size: 12px; line-height: 1.45; }\n        .workflow-floating-panel { scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent; }\n      "),
        react_1["default"].createElement("div", { style: {
                flex: 1,
                minHeight: 0,
                display: 'block',
                position: 'relative',
                overflow: 'hidden',
            }, onClick: function () {
                setEdgeMenu(null);
                setNodeMenu(null);
                setSelectedEdge(null);
            } },
            react_1["default"].createElement("div", { style: {
                    position: 'absolute',
                    top: 18,
                    left: '50%',
                    zIndex: 30,
                    minWidth: 180,
                    maxWidth: 420,
                    padding: '8px 16px',
                    transform: 'translateX(-50%)',
                    border: '1px solid #d8dee8',
                    borderRadius: 10,
                    background: 'rgba(244, 248, 252, .82)',
                    boxShadow: '0 5px 18px #1018281f',
                    backdropFilter: 'blur(12px)',
                    textAlign: 'center',
                    pointerEvents: 'none',
                } },
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, agentName)),
            status && (react_1["default"].createElement("div", { role: "status", "aria-live": "polite", style: {
                    position: 'absolute',
                    top: 68,
                    left: '50%',
                    zIndex: 31,
                    maxWidth: 520,
                    padding: '8px 13px',
                    transform: 'translateX(-50%)',
                    border: '1px solid #d8dee8',
                    borderRadius: 8,
                    color: '#344054',
                    background: '#fff',
                    boxShadow: '0 4px 12px #1018281a',
                    fontSize: 12,
                    pointerEvents: 'none',
                } }, status)),
            react_1["default"].createElement("div", { "aria-live": "polite", style: {
                    position: 'absolute',
                    left: 340,
                    right: 16,
                    bottom: 20,
                    zIndex: 40,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8,
                    pointerEvents: 'none',
                } }, toasts.map(function (toast) { return (react_1["default"].createElement("div", { key: toast.id, role: TOAST_TONES[toast.tone].role, style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                    maxWidth: 520,
                    padding: '10px 12px',
                    border: '1px solid #e4e7ec',
                    borderLeft: "4px solid " + TOAST_TONES[toast.tone].border,
                    borderRadius: 8,
                    color: '#111a38',
                    background: '#fff',
                    boxShadow: '0 8px 24px #1018281f',
                    fontSize: 13,
                    lineHeight: 1.4,
                    whiteSpace: 'pre-line',
                    pointerEvents: 'auto',
                } },
                react_1["default"].createElement("span", { style: { flex: 1 } }, toast.message),
                react_1["default"].createElement("button", { type: "button", "aria-label": "Dismiss message", onClick: function () { return dismissToast(toast.id); }, style: {
                        padding: 0,
                        border: 0,
                        color: '#667085',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: 16,
                        lineHeight: 1,
                    } }, "\u00D7"))); })),
            react_1["default"].createElement("aside", { className: "workflow-floating-panel", style: {
                    position: 'absolute',
                    zIndex: 26,
                    top: 20,
                    bottom: 20,
                    left: 20,
                    width: 300,
                    padding: '20px 20px 16px',
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    border: '1px solid rgba(216, 222, 232, .9)',
                    borderRadius: 22,
                    background: 'rgba(255, 255, 255, .94)',
                    boxShadow: '0 14px 36px #10182820',
                    backdropFilter: 'blur(16px)',
                } },
                react_1["default"].createElement("button", { type: "button", onClick: function () {
                        if (!dirtyNodeIds.size) {
                            onClose();
                            return;
                        }
                        confirmAction({
                            title: 'Leave the workflow builder?',
                            message: "Unsaved changes to " + dirtyNodeIds.size + " step" + (dirtyNodeIds.size === 1 ? '' : 's') + " will be lost if you leave.",
                            okTitle: 'Leave',
                            cancelTitle: 'Keep Editing',
                            onOk: onClose,
                        });
                    }, style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 7,
                        width: '100%',
                        margin: '0 0 18px',
                        padding: '4px 0',
                        border: 0,
                        color: '#111a38',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontWeight: 700,
                        textAlign: 'left',
                    } },
                    react_1["default"].createElement("span", { "aria-hidden": "true", style: { fontSize: 19 } }, "\u2190"),
                    "Back"),
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Add step"),
                NODE_TYPES.map(function (type) {
                    var _a;
                    return (react_1["default"].createElement("button", { type: "button", key: type.id, className: "workflow-palette-button", draggable: true, onDragStart: function (event) {
                            paletteDraggedRef.current = true;
                            event.dataTransfer.setData('workflow-node-type', type.id);
                            event.dataTransfer.effectAllowed = 'copy';
                        }, onDragEnd: function () {
                            window.setTimeout(function () {
                                paletteDraggedRef.current = false;
                            }, 0);
                        }, onClick: function () {
                            if (!paletteDraggedRef.current)
                                addNode(type.id);
                        }, disabled: type.id === 'fallback_node' &&
                            nodes.some(function (node) { return node.type === 'fallback_node'; }), style: (_a = {},
                            _a['--workflow-step-color'] = type.color,
                            _a.borderLeft = "5px solid " + type.color,
                            _a.color = type.id === 'fallback_node' &&
                                nodes.some(function (node) { return node.type === 'fallback_node'; })
                                ? '#667085'
                                : '#111a38',
                            _a) },
                        react_1["default"].createElement("span", { className: "workflow-palette-icon", style: { color: type.color, background: type.color + "18" } },
                            react_1["default"].createElement(WorkflowNodeIcon, { type: type.id })),
                        react_1["default"].createElement("span", { className: "workflow-palette-grip", "aria-hidden": "true" },
                            react_1["default"].createElement(drag_handle_svg_1["default"], { focusable: "false", draggable: false, style: { display: 'block', width: 24, height: 24 } })),
                        react_1["default"].createElement("span", { className: "workflow-palette-label" },
                            type.name,
                            type.id === 'fallback_node' &&
                                nodes.some(function (node) { return node.type === 'fallback_node'; }) && (react_1["default"].createElement("span", { className: "workflow-fallback-added" }, "(Already added)"))),
                        react_1["default"].createElement("span", { className: "workflow-palette-arrow", "aria-hidden": "true" }, "\u2192")));
                }),
                react_1["default"].createElement("div", { className: "workflow-palette-help" },
                    react_1["default"].createElement("span", { "aria-hidden": "true", style: { fontSize: 19, lineHeight: 1 } }, "\u24D8"),
                    react_1["default"].createElement("span", null, "Click or drag a step onto the canvas to add it to your workflow."))),
            react_1["default"].createElement("main", { ref: canvasRef, onPointerDownCapture: startPan, onMouseDown: function (event) {
                    // Middle-button drag pans; keep the browser's autoscroll out of it.
                    if (event.button === 1)
                        event.preventDefault();
                }, onClickCapture: function (event) {
                    if (!panJustEndedRef.current)
                        return;
                    panJustEndedRef.current = false;
                    event.stopPropagation();
                }, onClick: function (event) {
                    var target = event.target;
                    if (target.closest('.workflow-node-card'))
                        return;
                    if (connecting)
                        return;
                    setSelectedId(null);
                    setEdgeMenu(null);
                    setNodeMenu(null);
                    setSelectedEdge(null);
                }, onScroll: function (event) {
                    return setCanvasScroll({
                        left: event.currentTarget.scrollLeft,
                        top: event.currentTarget.scrollTop,
                    });
                }, onWheel: function (event) {
                    if (!event.ctrlKey && !event.metaKey)
                        return;
                    event.preventDefault();
                    var bounds = event.currentTarget.getBoundingClientRect();
                    zoomTo(zoom + (event.deltaY < 0 ? 0.03 : -0.03), {
                        x: event.clientX - bounds.left,
                        y: event.clientY - bounds.top,
                    });
                }, onDragOver: function (event) {
                    if (event.dataTransfer.types.includes('workflow-node-type')) {
                        event.preventDefault();
                        event.dataTransfer.dropEffect = 'copy';
                    }
                }, onDrop: function (event) {
                    var type = event.dataTransfer.getData('workflow-node-type');
                    if (!type)
                        return;
                    event.preventDefault();
                    var dropped = canvasPointFrom(event.clientX, event.clientY);
                    if (!dropped)
                        return;
                    var node = newNode(type, nodes.length, nodes, defaultLanguageCode, defaultAiModel, { provider: '', model: '' });
                    node.position_x = Math.round(dropped.x - NODE_WIDTH / 2);
                    node.position_y = Math.round(dropped.y - NODE_HEIGHT / 2);
                    if (type === 'fallback_node' &&
                        nodes.some(function (item) { return item.type === 'fallback_node'; })) {
                        notifyFailed('Only one default fallback step is allowed.');
                        return;
                    }
                    setNodes(function (current) { return __spreadArrays(current, [node]); });
                    setDirtyNodeIds(function (current) { return new Set(current).add(String(node.id)); });
                    selectNode(node);
                }, style: {
                    position: 'absolute',
                    inset: 0,
                    overflow: 'auto',
                    backgroundImage: 'radial-gradient(#dce1e9 1px, transparent 1px)',
                    backgroundSize: '22px 22px',
                    cursor: 'grab',
                } },
                react_1["default"].createElement("div", { ref: contentRef, style: {
                        position: 'relative',
                        width: canvasContentWidth,
                        height: canvasContentHeight,
                        marginLeft: CANVAS_GUTTER_X,
                        marginTop: CANVAS_GUTTER_Y,
                        // Shifted by the origin so steps left of / above 0 land inside
                        // the scrollable area instead of beyond its edge.
                        transform: "scale(" + zoom + ") translate(" + -graphOriginX + "px, " + -graphOriginY + "px)",
                        transformOrigin: 'top left',
                    } },
                    react_1["default"].createElement("svg", { width: canvasContentWidth, height: canvasContentHeight, style: { position: 'absolute', inset: 0, overflow: 'visible' } },
                        react_1["default"].createElement("defs", null,
                            react_1["default"].createElement("marker", { id: "workflow-arrow", viewBox: "0 0 10 10", refX: "9", refY: "5", markerWidth: "7", markerHeight: "7", orient: "auto-start-reverse" },
                                react_1["default"].createElement("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: "#64748b" }))),
                        connecting &&
                            connectionPoint &&
                            (function () {
                                var source = nodes.find(function (node) { return String(node.id) === String(connecting.sourceId); });
                                if (!source)
                                    return null;
                                var routeIndex = Math.max(0, routeKeys(source).findIndex(function (route) { return route.key === connecting.key; }));
                                var x1 = Number(source.position_x || 0) + NODE_WIDTH - 10;
                                var y1 = Number(source.position_y || 0) + 137 + routeIndex * 25;
                                var bend = Math.max(70, Math.abs(connectionPoint.x - x1) / 2);
                                return (react_1["default"].createElement("path", { d: "M " + x1 + " " + y1 + " C " + (x1 + bend) + " " + y1 + ", " + (connectionPoint.x - bend) + " " + connectionPoint.y + ", " + connectionPoint.x + " " + connectionPoint.y, fill: "none", stroke: "#146ef5", strokeWidth: "3", strokeDasharray: "8 6", markerEnd: "url(#workflow-arrow)", pointerEvents: "none" }));
                            })(),
                        nodes.flatMap(function (source) {
                            return (source.destinations || []).map(function (destination, index) {
                                var _a;
                                var target = nodes.find(function (node) {
                                    return String(node.id) === String(destination.target_node_id);
                                });
                                if (!target)
                                    return null;
                                var key = routeKeyForDestination(source, destination);
                                var sourceRouteIndex = Math.max(0, routeKeys(source).findIndex(function (route) { return route.key === key; }));
                                var sourceWidth = String(selectedId) === String(source.id)
                                    ? selectedCardWidth
                                    : NODE_WIDTH;
                                var x1 = source.position_x + sourceWidth - 10;
                                var y1 = source.position_y +
                                    (String(selectedId) === String(source.id)
                                        ? NODE_HEIGHT / 2
                                        : 137 + sourceRouteIndex * 25);
                                var x2 = target.position_x;
                                var y2 = target.position_y + NODE_HEIGHT / 2;
                                var point = edgePointFor(source, key);
                                var path = edgePath(x1, y1, x2, y2, point);
                                var isEdgeSelected = (selectedEdge === null || selectedEdge === void 0 ? void 0 : selectedEdge.sourceId) === source.id &&
                                    (selectedEdge === null || selectedEdge === void 0 ? void 0 : selectedEdge.key) === key;
                                var isRepointing = (connecting === null || connecting === void 0 ? void 0 : connecting.sourceId) === source.id &&
                                    (connecting === null || connecting === void 0 ? void 0 : connecting.key) === key;
                                var shapeX = point ? point.x : (x1 + x2) / 2;
                                var shapeY = point ? point.y : (y1 + y2) / 2;
                                return (react_1["default"].createElement("g", { className: "workflow-edge", key: source.id + "-" + index },
                                    react_1["default"].createElement("path", { d: path, fill: "none", stroke: "transparent", strokeWidth: "18", style: { cursor: 'pointer' }, onClick: function (event) {
                                            event.stopPropagation();
                                            setEdgeMenu({
                                                x: event.clientX,
                                                y: event.clientY,
                                                sourceId: source.id,
                                                key: key,
                                                targetId: target.id,
                                            });
                                            setSelectedEdge({
                                                sourceId: source.id,
                                                key: key,
                                                targetId: target.id,
                                            });
                                        }, onContextMenu: function (event) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            setEdgeMenu({
                                                x: event.clientX,
                                                y: event.clientY,
                                                sourceId: source.id,
                                                key: key,
                                                targetId: target.id,
                                            });
                                            setSelectedEdge({
                                                sourceId: source.id,
                                                key: key,
                                                targetId: target.id,
                                            });
                                        } }),
                                    react_1["default"].createElement("path", { d: path, fill: "none", stroke: isEdgeSelected ? '#146ef5' : '#64748b', strokeWidth: isEdgeSelected ? 5 : 3, opacity: isRepointing ? 0.25 : 1, markerEnd: "url(#workflow-arrow)", pointerEvents: "none" }),
                                    react_1["default"].createElement("text", { x: shapeX, y: shapeY - (point ? 16 : 7), textAnchor: "middle", fill: "#344054", fontSize: "11", fontWeight: "600", pointerEvents: "none", style: {
                                            paintOrder: 'stroke',
                                            stroke: '#fff',
                                            strokeWidth: 5,
                                        } }, ((_a = routeKeys(source).find(function (route) { return route.key === key; })) === null || _a === void 0 ? void 0 : _a.label) || key),
                                    react_1["default"].createElement("circle", { className: "workflow-edge-handle", "data-active": String(isEdgeSelected || Boolean(point)), cx: shapeX, cy: shapeY, r: 6, fill: "#fff", stroke: "#146ef5", strokeWidth: 2.5, style: { cursor: 'grab' }, onClick: function (event) { return event.stopPropagation(); }, onPointerDown: function (event) {
                                            return startEdgePointDrag(event, source, key);
                                        } },
                                        react_1["default"].createElement("title", null, "Drag to reshape this connection")),
                                    react_1["default"].createElement("circle", { className: "workflow-edge-handle", "data-active": String(isEdgeSelected), cx: x2 - 9, cy: y2, r: 7, fill: "#146ef5", stroke: "#fff", strokeWidth: 2, style: { cursor: 'crosshair' }, onClick: function (event) { return event.stopPropagation(); }, onPointerDown: function (event) {
                                            return startConnectionDrag(event, source, key);
                                        } },
                                        react_1["default"].createElement("title", null, "Drag onto another step to re-point this connection"))));
                            });
                        }),
                        (selected === null || selected === void 0 ? void 0 : selected.type) === 'bot_response' &&
                            responseReferences(selected.id).map(function (reference, index) {
                                var x1 = selected.position_x + selectedCardWidth - 10;
                                var y1 = selected.position_y + NODE_HEIGHT / 2;
                                var x2 = reference.source.position_x + 10;
                                var y2 = reference.source.position_y + NODE_HEIGHT / 2;
                                var bend = Math.max(70, Math.abs(x2 - x1) * 0.48);
                                var path = "M " + x1 + " " + y1 + " C " + (x1 + bend) + " " + y1 + ", " + (x2 - bend) + " " + y2 + ", " + x2 + " " + y2;
                                return (react_1["default"].createElement("g", { key: "reference-" + reference.source.id + "-" + index },
                                    react_1["default"].createElement("path", { d: path, fill: "none", stroke: "transparent", strokeWidth: "18", style: { cursor: 'pointer' }, onClick: function (event) {
                                            event.stopPropagation();
                                            setNodeMenu({
                                                x: event.clientX,
                                                y: event.clientY,
                                                title: 'Response reference',
                                                items: [
                                                    {
                                                        label: "Go to source \u2192 " + selected.node_name,
                                                        node: selected,
                                                    },
                                                    {
                                                        label: "Go to destination \u2192 " + reference.source.node_name,
                                                        node: reference.source,
                                                    },
                                                ],
                                            });
                                        } }),
                                    react_1["default"].createElement("path", { d: path, fill: "none", stroke: "#2e90fa", strokeWidth: "3", strokeDasharray: "8 6", pointerEvents: "none" }),
                                    react_1["default"].createElement("text", { x: (x1 + x2) / 2, y: (y1 + y2) / 2 - 7, textAnchor: "middle", fill: "#175cd3", fontSize: "11", style: {
                                            paintOrder: 'stroke',
                                            stroke: '#fff',
                                            strokeWidth: 5,
                                        } }, reference.label)));
                            })),
                    nodes
                        .filter(function (node) { return node.is_entry || isImplicitStart(node); })
                        .map(function (node) { return (react_1["default"].createElement("div", { key: "start-" + node.id, style: {
                            position: 'absolute',
                            left: Number(node.position_x || 0) - 108,
                            top: Number(node.position_y || 0) + 34,
                            zIndex: 6,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7,
                            color: '#067647',
                            fontSize: 12,
                            fontWeight: 800,
                            pointerEvents: 'none',
                        } },
                        react_1["default"].createElement("span", { style: {
                                padding: '5px 9px',
                                border: '1px solid #86efac',
                                borderRadius: 999,
                                background: '#ecfdf3',
                            } }, "START"),
                        react_1["default"].createElement("span", { style: { fontSize: 25, lineHeight: 1 } }, "\u2192"))); }),
                    nodes.map(function (node) {
                        var _a, _b;
                        return (react_1["default"].createElement("div", { key: node.id, className: "workflow-node-card", "data-node-id": String(node.id), "data-selected": String(selectedId) === String(node.id), onPointerDown: function (event) { return beginNodeDrag(event, node); }, onClick: function (event) {
                                event.stopPropagation();
                                if (dragJustEndedRef.current) {
                                    dragJustEndedRef.current = false;
                                    return;
                                }
                                if (connectionJustDroppedRef.current) {
                                    connectionJustDroppedRef.current = false;
                                    return;
                                }
                                if (connecting &&
                                    String(connecting.sourceId) !== String(node.id)) {
                                    var source = nodes.find(function (item) { return String(item.id) === String(connecting.sourceId); });
                                    if (source && !node._draft) {
                                        updateNodeRoute(source, connecting.key, String(node.id));
                                        setConnecting(null);
                                    }
                                    return;
                                }
                                selectNode(node);
                            }, onContextMenu: function (event) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (node.type === 'bot_response') {
                                    var references = responseReferences(node.id);
                                    if (!references.length) {
                                        setStatus('This response step is not referenced by a parameter or tool.');
                                        return;
                                    }
                                    setNodeMenu({
                                        x: event.clientX,
                                        y: event.clientY,
                                        title: 'Used by',
                                        items: references.map(function (reference) { return ({
                                            label: reference.label + " \u2192 " + reference.source.node_name,
                                            node: reference.source,
                                        }); }),
                                    });
                                    return;
                                }
                                var items = routeKeys(node)
                                    .map(function (route) { return ({
                                    route: route,
                                    destination: destinationFor(node, route.key),
                                }); })
                                    .map(function (item) { return (__assign(__assign({}, item), { target: nodes.find(function (target) {
                                        var _a;
                                        return String(target.id) ===
                                            String((_a = item.destination) === null || _a === void 0 ? void 0 : _a.target_node_id);
                                    }) })); })
                                    .filter(function (item) { return item.target; })
                                    .map(function (item) { return ({
                                    label: item.route.label + " \u2192 " + item.target.node_name,
                                    node: item.target,
                                }); });
                                if (!items.length) {
                                    setStatus('This step has no configured destination.');
                                    return;
                                }
                                setNodeMenu({
                                    x: event.clientX,
                                    y: event.clientY,
                                    title: 'Go to destination',
                                    items: items,
                                });
                            }, style: {
                                position: 'absolute',
                                left: node.position_x,
                                top: node.position_y,
                                width: String(selectedId) === String(node.id)
                                    ? selectedCardWidth
                                    : NODE_WIDTH,
                                minHeight: NODE_HEIGHT,
                                padding: 0,
                                // A hand, like the canvas: the whole card can be grabbed
                                // and moved, apart from its buttons and route handles.
                                cursor: 'grab',
                                background: '#fff',
                                borderRadius: 10,
                                border: String(selectedId) === String(node.id)
                                    ? '2px solid #146ef5'
                                    : '1px solid #d8dee8',
                                borderTop: "4px solid " + (((_a = NODE_TYPES.find(function (type) { return type.id === node.type; })) === null || _a === void 0 ? void 0 : _a.color) ||
                                    '#146ef5'),
                                boxShadow: '0 4px 14px #1018281a',
                                outline: String(focusedId) === String(node.id)
                                    ? '4px solid #f79009'
                                    : selectedEdge &&
                                        (String(selectedEdge.sourceId) === String(node.id) ||
                                            String(selectedEdge.targetId) === String(node.id))
                                        ? '4px solid #146ef5'
                                        : undefined,
                            } },
                            dirtyNodeIds.has(String(node.id)) && (react_1["default"].createElement("span", { style: {
                                    position: 'absolute',
                                    right: 8,
                                    top: -13,
                                    zIndex: 3,
                                    padding: '2px 7px',
                                    border: '1px solid #fed7aa',
                                    borderRadius: 10,
                                    color: '#b54708',
                                    background: '#fff7ed',
                                    fontSize: 10,
                                } }, "Unsaved")),
                            react_1["default"].createElement("div", { style: {
                                    display: 'flex',
                                    gap: 11,
                                    alignItems: 'center',
                                    padding: '12px 13px',
                                    borderBottom: '1px solid #f0f2f6',
                                } },
                                react_1["default"].createElement("span", { style: {
                                        width: 40,
                                        height: 40,
                                        display: 'grid',
                                        placeItems: 'center',
                                        flex: '0 0 auto',
                                        borderRadius: 10,
                                        background: '#f3f7ff',
                                        color: ((_b = NODE_TYPES.find(function (type) { return type.id === node.type; })) === null || _b === void 0 ? void 0 : _b.color) || '#146ef5',
                                        fontSize: 21,
                                    } },
                                    react_1["default"].createElement(WorkflowNodeIcon, { type: node.type })),
                                react_1["default"].createElement("div", { style: { minWidth: 0, flex: 1 } },
                                    react_1["default"].createElement("div", { style: {
                                            fontWeight: 750,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        } }, node.node_name),
                                    react_1["default"].createElement("div", { style: {
                                            color: '#667085',
                                            fontSize: 11,
                                            textTransform: 'uppercase',
                                            letterSpacing: '.04em',
                                        } }, titleFor(node.type))),
                                node.is_entry && (react_1["default"].createElement("span", { style: {
                                        padding: '3px 6px',
                                        borderRadius: 10,
                                        color: '#067647',
                                        background: '#ecfdf3',
                                        fontSize: 10,
                                        fontWeight: 700,
                                    } }, "ENTRY")),
                                isImplicitStart(node) && (react_1["default"].createElement("span", { title: "No step is marked as the entry step, so the call starts here.", style: {
                                        padding: '3px 6px',
                                        border: '1px dashed #86efac',
                                        borderRadius: 10,
                                        color: '#067647',
                                        background: '#ecfdf3',
                                        fontSize: 10,
                                        fontWeight: 700,
                                        whiteSpace: 'nowrap',
                                    } }, "Start step"))),
                            node.type === 'bot_response' &&
                                responseReferences(node.id).length > 0 && (react_1["default"].createElement("span", { style: {
                                    position: 'absolute',
                                    top: -12,
                                    right: 8,
                                    padding: '2px 7px',
                                    border: '1px solid #b2ddff',
                                    borderRadius: 10,
                                    color: '#175cd3',
                                    background: '#eff8ff',
                                    fontSize: 10,
                                } },
                                "Referenced by: ",
                                responseReferences(node.id).length)),
                            String(selectedId) !== String(node.id) && (react_1["default"].createElement("div", { style: {
                                    padding: '12px 13px',
                                    color: '#475467',
                                    fontSize: 12,
                                } },
                                react_1["default"].createElement("div", { style: {
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        wordBreak: 'break-word',
                                    } }, summaryFor(node, tools, defaultLanguageCode)))),
                            routeKeys(node).map(function (route, routeIndex) {
                                var _a;
                                return (react_1["default"].createElement("div", { key: route.key, className: "workflow-node-route", style: {
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        gap: 7,
                                        minHeight: 25,
                                        padding: '2px 7px',
                                        borderTop: routeIndex === 0 ? '1px solid #f0f2f6' : 0,
                                        color: '#475467',
                                        fontSize: 11,
                                    } },
                                    react_1["default"].createElement("span", null, route.shortLabel || route.label),
                                    react_1["default"].createElement("button", { type: "button", "aria-label": "Connect " + route.label, onPointerDown: function (event) {
                                            return startConnectionDrag(event, node, route.key);
                                        }, onClick: function (event) {
                                            event.stopPropagation();
                                        }, style: {
                                            position: 'static',
                                            width: 20,
                                            height: 20,
                                            flex: '0 0 auto',
                                            padding: 0,
                                            borderRadius: '50%',
                                            border: "3px solid " + ((_a = NODE_TYPES.find(function (type) { return type.id === node.type; })) === null || _a === void 0 ? void 0 : _a.color),
                                            background: (connecting === null || connecting === void 0 ? void 0 : connecting.sourceId) === node.id &&
                                                (connecting === null || connecting === void 0 ? void 0 : connecting.key) === route.key
                                                ? '#146ef5'
                                                : '#fff',
                                            cursor: 'crosshair',
                                        } })));
                            })));
                    }))),
            react_1["default"].createElement("aside", { className: "workflow-node-editor", "data-node-id": selected ? String(selected.id) : undefined, style: {
                    display: selected ? 'block' : 'none',
                    position: 'absolute',
                    zIndex: 20,
                    left: Math.max(PALETTE_CLEARANCE, Math.min(toScrollX(Number((selected === null || selected === void 0 ? void 0 : selected.position_x) || 0)) -
                        canvasScroll.left, (((_k = canvasRef.current) === null || _k === void 0 ? void 0 : _k.clientWidth) || 1000) -
                        EDITOR_PANEL_WIDTH -
                        EDITOR_EDGE_GAP)),
                    top: editorTop,
                    width: EDITOR_PANEL_WIDTH,
                    maxHeight: editorMaxHeight,
                    // No top or bottom padding: the header and the Save Step / Delete
                    // footer pin at exactly 0. Browsers disagree on whether a scroll
                    // container's padding counts for sticky offsets, so negative
                    // offsets that cancel the padding could leave the footer partly
                    // off the bottom edge, looking as if it scrolled with the fields.
                    padding: '0 16px',
                    // Its own scroll container, so the sticky header and the Save
                    // Step / Delete footer stay pinned while the fields scroll.
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    overscrollBehavior: 'contain',
                    background: '#fff',
                    border: '1px solid #d8dee8',
                    borderTop: "4px solid " + (((_l = NODE_TYPES.find(function (type) { return type.id === (selected === null || selected === void 0 ? void 0 : selected.type); })) === null || _l === void 0 ? void 0 : _l.color) ||
                        '#146ef5'),
                    borderRadius: 12,
                    boxShadow: '0 14px 34px #1018282b',
                }, onClick: function (event) {
                    event.stopPropagation();
                    if (connectionJustDroppedRef.current) {
                        connectionJustDroppedRef.current = false;
                        return;
                    }
                    if (!connecting || !selected)
                        return;
                    var source = nodes.find(function (node) { return String(node.id) === String(connecting.sourceId); });
                    if (source &&
                        !selected._draft &&
                        String(source.id) !== String(selected.id)) {
                        updateNodeRoute(source, connecting.key, String(selected.id));
                        setConnecting(null);
                    }
                }, onWheel: function (event) {
                    // Let the editor scroll its own fields when they overflow; only a
                    // short editor hands the wheel on to the canvas behind it.
                    var panel = event.currentTarget;
                    if (panel.scrollHeight > panel.clientHeight + 1)
                        return;
                    if (!canvasRef.current)
                        return;
                    canvasRef.current.scrollTop += event.deltaY;
                    canvasRef.current.scrollLeft += event.deltaX;
                } }, !selected ? (react_1["default"].createElement(text_1["default"], { color: "grey.dark" }, "Select a step to edit it.")) : (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 11,
                        margin: '0 -16px 14px',
                        padding: '12px 13px',
                        borderBottom: '1px solid #f0f2f6',
                        // Pinned to the top while the fields scroll, like the footer.
                        position: 'sticky',
                        top: 0,
                        zIndex: 3,
                        background: '#fff',
                        // The header moves the open step, like the closed card.
                        cursor: 'grab',
                    }, onPointerDown: function (event) { return beginNodeDrag(event, selected); } },
                    react_1["default"].createElement("span", { style: {
                            width: 40,
                            height: 40,
                            display: 'grid',
                            placeItems: 'center',
                            flex: '0 0 auto',
                            borderRadius: 10,
                            color: ((_m = NODE_TYPES.find(function (type) { return type.id === selected.type; })) === null || _m === void 0 ? void 0 : _m.color) || '#146ef5',
                            background: '#f3f7ff',
                            fontSize: 21,
                        } },
                        react_1["default"].createElement(WorkflowNodeIcon, { type: selected.type })),
                    react_1["default"].createElement("div", { style: { minWidth: 0, flex: 1 } },
                        react_1["default"].createElement("div", { style: { fontWeight: 750 } }, selected.node_name),
                        react_1["default"].createElement("div", { style: {
                                color: '#667085',
                                fontSize: 11,
                                textTransform: 'uppercase',
                                letterSpacing: '.04em',
                            } }, titleFor(selected.type))),
                    selected.is_entry && (react_1["default"].createElement("span", { style: {
                            padding: '3px 6px',
                            borderRadius: 10,
                            color: '#067647',
                            background: '#ecfdf3',
                            fontSize: 10,
                            fontWeight: 700,
                        } }, "ENTRY")),
                    react_1["default"].createElement("button", { type: "button", "aria-label": "Collapse step settings", onClick: function () {
                            // The editor is clamped clear of the palette, so the step
                            // it belongs to can be off-screen by the time it closes.
                            // Collapse back onto the step rather than wherever the
                            // canvas happened to be scrolled.
                            var collapsing = selected;
                            setSelectedId(null);
                            focusNode(collapsing);
                        }, style: { border: 0, background: 'transparent', fontSize: 20 } }, "\u00D7")),
                react_1["default"].createElement(text_2["default"], { themed: true, label: "Step name", value: selected.node_name || '', onChange: function (value) { return updateSelected({ node_name: value }); } }),
                duplicateNameNode && (react_1["default"].createElement("span", { style: {
                        display: 'block',
                        marginTop: 4,
                        color: '#b42318',
                        fontSize: 11,
                    } }, "Another step already uses this name. Step names must be unique.")),
                react_1["default"].createElement("label", { title: existingEntryNode
                        ? "Entry step is already set to " + existingEntryNode.node_name
                        : undefined },
                    react_1["default"].createElement("input", { type: "checkbox", checked: Boolean(selected.is_entry), disabled: Boolean(existingEntryNode), onChange: function (event) { return setEntry(event.target.checked); } }),
                    ' ',
                    "Entry step",
                    existingEntryNode && (react_1["default"].createElement("span", { style: {
                            display: 'block',
                            marginTop: 4,
                            color: '#667085',
                            fontSize: 11,
                            fontWeight: 400,
                        } },
                        "Entry step already set to ",
                        existingEntryNode.node_name,
                        ".")),
                    isImplicitStart(selected) && (react_1["default"].createElement("span", { style: {
                            display: 'block',
                            marginTop: 4,
                            color: '#067647',
                            fontSize: 11,
                            fontWeight: 400,
                        } }, "No step is marked as the entry step, so this step will be used as the start step."))),
                selected.type === 'bot_response' &&
                    responseGroups.map(function (_a) {
                        var languageCode = _a[0], variations = _a[1];
                        var collapsed = collapsedLanguages.has(languageCode);
                        var unsupported = !isSupportedLanguage(languageCode);
                        return (react_1["default"].createElement("section", { key: languageCode, style: {
                                marginTop: 14,
                                padding: 12,
                                border: '1px solid #e3e7ef',
                                borderLeft: "4px solid " + (unsupported ? '#98a2b3' : '#11b8bd'),
                                borderRadius: 10,
                                background: unsupported ? '#f9fafb' : '#fff',
                            } },
                            react_1["default"].createElement("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    marginBottom: collapsed ? 0 : 12,
                                } },
                                react_1["default"].createElement("span", { style: {
                                        width: 38,
                                        height: 38,
                                        display: 'grid',
                                        placeItems: 'center',
                                        borderRadius: '50%',
                                        color: '#fff',
                                        background: unsupported ? '#98a2b3' : '#11b8bd',
                                        fontWeight: 700,
                                    } }, languageCode.toUpperCase()),
                                react_1["default"].createElement("strong", { style: {
                                        fontSize: 16,
                                        color: unsupported ? '#667085' : undefined,
                                    } }, languageNameFor(languageCode)),
                                unsupported && (react_1["default"].createElement("span", { style: {
                                        padding: '3px 8px',
                                        borderRadius: 10,
                                        color: '#475467',
                                        background: '#eaecf0',
                                        fontSize: 11,
                                        fontWeight: 700,
                                    } }, "Not supported")),
                                react_1["default"].createElement("button", { type: "button", onClick: function () {
                                        return setCollapsedLanguages(function (current) {
                                            var next = new Set(current);
                                            if (next.has(languageCode))
                                                next["delete"](languageCode);
                                            else
                                                next.add(languageCode);
                                            return next;
                                        });
                                    }, style: {
                                        marginLeft: 'auto',
                                        padding: '7px 10px',
                                        border: 0,
                                        borderRadius: 8,
                                        color: '#111a38',
                                        background: '#f5f6f8',
                                        cursor: 'pointer',
                                    } },
                                    variations.length,
                                    ' ',
                                    variations.length === 1 ? 'Variation' : 'Variations',
                                    ' ',
                                    collapsed ? '⌄' : '⌃')),
                            !collapsed && unsupported && (react_1["default"].createElement("div", { style: {
                                    marginBottom: 10,
                                    padding: 8,
                                    borderRadius: 7,
                                    color: '#475467',
                                    background: '#f2f4f7',
                                    fontSize: 12,
                                } },
                                "This language is not supported by the bot, so these responses are never spoken in a call and can't be edited. Add ",
                                languageNameFor(languageCode),
                                " back in the bot settings to use them again.")),
                            !collapsed &&
                                variations.map(function (_a, groupIndex) {
                                    var response = _a.response, index = _a.index;
                                    return (react_1["default"].createElement("div", { key: response.id || languageCode + "-" + index, style: editorCardStyle },
                                        react_1["default"].createElement("div", { style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                            } },
                                            react_1["default"].createElement("strong", null,
                                                "Variation ",
                                                groupIndex + 1),
                                            react_1["default"].createElement("span", { style: { marginLeft: 'auto' } }),
                                            !unsupported && isSpokenLive(response) && (react_1["default"].createElement("span", { title: LIVE_TTS_HINT, "aria-label": LIVE_TTS_HINT, style: {
                                                    padding: '4px 8px',
                                                    borderRadius: 8,
                                                    color: '#6941c6',
                                                    background: '#f4f3ff',
                                                    fontSize: 11,
                                                    fontWeight: 700,
                                                    cursor: 'help',
                                                } }, "Spoken live")),
                                            !unsupported && hasAudioPreview(response) && (react_1["default"].createElement(react_1["default"].Fragment, null,
                                                react_1["default"].createElement("button", { type: "button", disabled: generatingResponseIndex !== null, title: response.response_url
                                                        ? 'Regenerate audio'
                                                        : 'Generate audio', "aria-label": response.response_url
                                                        ? 'Regenerate audio'
                                                        : 'Generate audio', onClick: function () {
                                                        return generateAndPlayResponseAudio(index);
                                                    }, style: __assign(__assign(__assign({}, audioIconButtonStyle), (generatingResponseIndex !== null
                                                        ? audioIconButtonDisabledStyle
                                                        : {})), { width: 'auto', display: 'flex', gap: 6, padding: '0 9px' }) },
                                                    react_1["default"].createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", style: {
                                                            animation: generatingResponseIndex === index
                                                                ? 'workflow-spin .8s linear infinite'
                                                                : undefined,
                                                        } },
                                                        react_1["default"].createElement("path", { d: "M20 11a8 8 0 1 0-2.34 5.66M20 5v6h-6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
                                                    react_1["default"].createElement("span", { style: { fontSize: 12, fontWeight: 700 } }, response.response_url
                                                        ? 'Regenerate'
                                                        : 'Generate')),
                                                react_1["default"].createElement("button", { type: "button", disabled: Boolean(playDisabledReason(response, index)), title: playDisabledReason(response, index) ||
                                                        (playingResponseIndex === index
                                                            ? 'Pause audio'
                                                            : 'Play audio'), "aria-label": playingResponseIndex === index
                                                        ? 'Pause audio'
                                                        : 'Play audio', onClick: function () {
                                                        return playResponseAudio(response, index);
                                                    }, style: __assign(__assign({}, audioIconButtonStyle), (playDisabledReason(response, index)
                                                        ? audioIconButtonDisabledStyle
                                                        : {})) },
                                                    react_1["default"].createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, playingResponseIndex === index ? (react_1["default"].createElement("path", { d: "M7 5h4v14H7zM13 5h4v14h-4z" })) : (react_1["default"].createElement("path", { d: "M8 5.5v13a1 1 0 0 0 1.55.83l9-6.5a1 1 0 0 0 0-1.66l-9-6.5A1 1 0 0 0 8 5.5Z" })))))),
                                            !unsupported && (react_1["default"].createElement("button", { type: "button", title: "Delete variation", "aria-label": "Delete variation", onClick: function () {
                                                    return confirmAction({
                                                        title: 'Delete this variation?',
                                                        message: 'The variation is removed from this step. Save the step to keep the change.',
                                                        okTitle: 'Delete',
                                                        onOk: function () {
                                                            return updateSelected({
                                                                responses: selected.responses.filter(function (_, responseIndex) {
                                                                    return responseIndex !== index;
                                                                }),
                                                            });
                                                        },
                                                    });
                                                }, style: __assign(__assign({}, audioIconButtonStyle), { color: '#f04438', border: 0 }) },
                                                react_1["default"].createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" },
                                                    react_1["default"].createElement("path", { d: "M4 7h16M9 7V4h6v3m-9 0 1 13h10l1-13M10 11v5m4-5v5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))),
                                        react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "Response", disabled: unsupported, value: response.response || '', error: (response.response || '').length >
                                                RESPONSE_MAX_LENGTH, onChange: function (value) {
                                                return updateResponse(index, 'response', value);
                                            } }),
                                        react_1["default"].createElement("div", { style: {
                                                color: (response.response || '').length >
                                                    RESPONSE_MAX_LENGTH
                                                    ? '#b42318'
                                                    : '#667085',
                                                fontSize: 11,
                                                textAlign: 'right',
                                            } },
                                            (response.response || '').length,
                                            "/",
                                            RESPONSE_MAX_LENGTH),
                                        (response.response || '').length >
                                            RESPONSE_MAX_LENGTH && (react_1["default"].createElement(FieldError, null, RESPONSE_TOO_LONG)),
                                        /\{[A-Za-z_][A-Za-z0-9_]*\}/.test(response.response || '') && (react_1["default"].createElement("div", { style: {
                                                marginTop: 8,
                                                padding: 8,
                                                borderRadius: 7,
                                                color: '#6941c6',
                                                background: '#f4f3ff',
                                                fontSize: 12,
                                            } }, "Dynamic response: audio uses live TTS."))));
                                }),
                            !collapsed && !unsupported && (react_1["default"].createElement("button", { type: "button", onClick: function () {
                                    return updateSelected({
                                        responses: __spreadArrays((selected.responses || []), [
                                            {
                                                language_code: languageCode,
                                                response: '',
                                                response_url: null,
                                            },
                                        ]),
                                    });
                                }, style: {
                                    border: 0,
                                    color: '#146ef5',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    fontWeight: 700,
                                } }, "\uFF0B Add Variation"))));
                    }),
                selected.type === 'bot_response' && unusedLanguages.length > 0 && (react_1["default"].createElement("div", { style: { marginTop: 12 } }, isAddingLanguage ? (react_1["default"].createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: 10,
                        border: '1px solid #e3e7ef',
                        borderRadius: 9,
                        background: '#fcfcfd',
                    } },
                    react_1["default"].createElement("select", { "aria-label": "Select response language", value: newLanguageCode, onChange: function (event) {
                            return setNewLanguageCode(event.target.value);
                        }, style: { flex: 1 } },
                        react_1["default"].createElement("option", { value: "" }, "Select language"),
                        unusedLanguages.map(function (language) { return (react_1["default"].createElement("option", { key: language.code, value: language.code },
                            language.name,
                            " (",
                            language.code.toUpperCase(),
                            ")")); })),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", disabled: !newLanguageCode, onClick: function () {
                            if (!newLanguageCode)
                                return;
                            updateSelected({
                                responses: __spreadArrays((selected.responses || []), [
                                    {
                                        language_code: newLanguageCode,
                                        response: '',
                                        response_url: null,
                                    },
                                ]),
                            });
                            setCollapsedLanguages(function (current) {
                                var next = new Set(current);
                                next["delete"](newLanguageCode);
                                return next;
                            });
                            setNewLanguageCode('');
                            setIsAddingLanguage(false);
                        } }, "Add"),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                            setNewLanguageCode('');
                            setIsAddingLanguage(false);
                        } }, "Cancel"))) : (react_1["default"].createElement("button", { type: "button", onClick: function () { return setIsAddingLanguage(true); }, style: {
                        border: 0,
                        color: '#146ef5',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontWeight: 700,
                    } }, "\uFF0B Add Language")))),
                selected.type === 'bot_response' && (react_1["default"].createElement("div", { style: editorCardStyle },
                    react_1["default"].createElement("label", null,
                        "After response",
                        react_1["default"].createElement("select", { value: routeActionFor(selected), onChange: function (event) {
                                var _a;
                                var destinations = ((_a = selected.destinations) === null || _a === void 0 ? void 0 : _a.length) ? [
                                    __assign(__assign({}, selected.destinations[0]), { on_action: event.target.value }),
                                ]
                                    : selected.destinations;
                                updateSelected({
                                    destinations: destinations,
                                    metadata: __assign(__assign({}, (selected.metadata || {})), { route_action: event.target.value }),
                                });
                            } },
                            react_1["default"].createElement("option", { value: "user_reply" }, "Wait for user reply"),
                            react_1["default"].createElement("option", { value: "immediate" }, "Continue immediately"))),
                    routeActionFor(selected) === 'user_reply' && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement("label", null,
                            react_1["default"].createElement("input", { type: "checkbox", checked: Boolean((_p = (_o = selected.config) === null || _o === void 0 ? void 0 : _o.user_pause_duration) === null || _p === void 0 ? void 0 : _p.enabled), onChange: function (event) {
                                    var _a, _b;
                                    return updateSelected({
                                        config: __assign(__assign({}, selected.config), { user_pause_duration: {
                                                enabled: event.target.checked,
                                                seconds: ((_b = (_a = selected.config) === null || _a === void 0 ? void 0 : _a.user_pause_duration) === null || _b === void 0 ? void 0 : _b.seconds) || 0.3,
                                            } }),
                                    });
                                } }),
                            ' ',
                            "Enable User Pause Duration"),
                        ((_r = (_q = selected.config) === null || _q === void 0 ? void 0 : _q.user_pause_duration) === null || _r === void 0 ? void 0 : _r.enabled) && (react_1["default"].createElement("label", null,
                            "User Pause Duration:",
                            ' ',
                            Number(selected.config.user_pause_duration.seconds || 0.3).toFixed(1),
                            ' ',
                            "seconds",
                            react_1["default"].createElement("input", { type: "range", min: "0.2", max: "2", step: "0.1", value: selected.config.user_pause_duration.seconds || 0.3, onChange: function (event) {
                                    return updateSelected({
                                        config: __assign(__assign({}, selected.config), { user_pause_duration: {
                                                enabled: true,
                                                seconds: Number(event.target.value),
                                            } }),
                                    });
                                } }))))),
                    react_1["default"].createElement(StepPicker, { label: "Next step", emptyLabel: "No next step", value: (_s = destinationFor(selected, 'main')) === null || _s === void 0 ? void 0 : _s.target_node_id, steps: nodes.filter(function (node) {
                            return String(node.id) !== String(selected.id) && !node._draft;
                        }), onChange: function (nodeId) { return updateRoute('main', nodeId); } }))),
                ['intent_detection', 'capture_parameter'].includes(selected.type) && (react_1["default"].createElement("div", { style: editorCardStyle },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "AI Configuration"),
                    react_1["default"].createElement(ModelPicker, { models: selected.type === 'intent_detection'
                            ? intentModels
                            : models, provider: selected.type === 'intent_detection'
                            ? selectedIntentModel.provider || ''
                            : ((_u = (_t = selected.config) === null || _t === void 0 ? void 0 : _t.ai_model) === null || _u === void 0 ? void 0 : _u.provider) || '', model: selected.type === 'intent_detection'
                            ? selectedIntentModel.model || ''
                            : ((_w = (_v = selected.config) === null || _v === void 0 ? void 0 : _v.ai_model) === null || _w === void 0 ? void 0 : _w.model) || '', onChange: function (selection) {
                            if (selected.type === 'intent_detection') {
                                updateSelected({
                                    config: __assign(__assign({}, selected.config), { intent_model: selection }),
                                });
                                return;
                            }
                            updateSelected({
                                config: __assign(__assign({}, selected.config), { ai_model: {
                                        provider: selection.provider,
                                        model: selection.model,
                                    } }),
                            });
                        } }),
                    react_1["default"].createElement("label", null,
                        "Conversation context",
                        react_1["default"].createElement("input", { type: "number", min: "0", value: ((_x = selected.config) === null || _x === void 0 ? void 0 : _x.conversation_context) || 0, onChange: function (event) {
                                return updateSelected({
                                    config: __assign(__assign({}, selected.config), { conversation_context: Number(event.target.value) }),
                                });
                            } })),
                    react_1["default"].createElement("label", null,
                        react_1["default"].createElement("input", { type: "checkbox", checked: Boolean((_y = selected.config) === null || _y === void 0 ? void 0 : _y.date_time_context_enabled), onChange: function (event) {
                                return updateSelected({
                                    config: __assign(__assign({}, selected.config), { date_time_context_enabled: event.target.checked }),
                                });
                            } }),
                        ' ',
                        "Enable date and time context"))),
                selected.type === 'intent_detection' && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Intents"),
                    (((_z = selected.config) === null || _z === void 0 ? void 0 : _z.intents) || []).map(function (intent, index) { return (react_1["default"].createElement("div", { key: index, style: editorCardStyle },
                        react_1["default"].createElement(text_2["default"], { themed: true, label: "Intent name", value: intent.name || '', onChange: function (value) {
                                return updateConfigItem('intents', index, { name: value });
                            } }),
                        react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "Description", value: intent.description || '', onChange: function (value) {
                                return updateConfigItem('intents', index, {
                                    description: value,
                                });
                            } }),
                        react_1["default"].createElement(text_2["default"], { themed: true, label: "Keywords (comma separated)", value: (intent.keywords || []).join(', '), onChange: function (value) {
                                return updateConfigItem('intents', index, {
                                    keywords: value
                                        .split(',')
                                        .map(function (keyword) { return keyword.trim(); })
                                        .filter(Boolean),
                                });
                            } }),
                        react_1["default"].createElement(button_1["default"], { themed: true, variant: "warning", onClick: function () { return removeConfigItem('intents', index); } }, "Remove intent"))); }),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                            return addConfigItem('intents', {
                                name: 'New intent',
                                description: '',
                                keywords: [],
                            });
                        } }, "Add intent"))),
                selected.type === 'capture_parameter' && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Parameters"),
                    (((_0 = selected.config) === null || _0 === void 0 ? void 0 : _0.parameters) || []).map(function (parameter, index) { return (react_1["default"].createElement("div", { key: index, style: editorCardStyle },
                        react_1["default"].createElement(text_2["default"], { themed: true, label: "Parameter name", value: parameter.name || '', error: Boolean(parameterNameError(parameter.name)), onChange: function (value) {
                                return updateConfigItem('parameters', index, {
                                    name: value.trim(),
                                });
                            } }),
                        parameterNameError(parameter.name) && (react_1["default"].createElement(FieldError, null, PARAMETER_NAME_HINT)),
                        react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "Description", value: parameter.description || '', onChange: function (value) {
                                return updateConfigItem('parameters', index, {
                                    description: value,
                                });
                            } }),
                        react_1["default"].createElement("label", { style: { display: 'block', margin: '8px 0' } },
                            "Type",
                            react_1["default"].createElement("select", { value: parameter.type || 'string', onChange: function (event) {
                                    return updateConfigItem('parameters', index, {
                                        type: event.target.value,
                                    });
                                } }, VoiceAgentLayoutUtils_1.PARAMETER_TYPE_OPTIONS.map(function (option) { return (react_1["default"].createElement("option", { key: option.id, value: option.id }, option.name)); }))),
                        react_1["default"].createElement("label", null,
                            react_1["default"].createElement("input", { type: "checkbox", checked: Boolean(parameter.required), onChange: function (event) {
                                    return updateConfigItem('parameters', index, {
                                        required: event.target.checked,
                                    });
                                } }),
                            ' ',
                            "Required"),
                        parameter.required && (react_1["default"].createElement(react_1["default"].Fragment, null,
                            react_1["default"].createElement(StepPicker, { label: "Prompt response step", emptyLabel: "Select Bot Response step", value: parameter.response_node_id, steps: nodes.filter(function (node) {
                                    return node.type === 'bot_response' && !node._draft;
                                }), onChange: function (nodeId) {
                                    return updateConfigItem('parameters', index, {
                                        response_node_id: Number(nodeId) || null,
                                    });
                                } }),
                            parameter.response_node_id && (react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                                    var responseNode = nodes.find(function (node) {
                                        return String(node.id) ===
                                            String(parameter.response_node_id);
                                    });
                                    if (responseNode)
                                        focusNode(responseNode);
                                } }, "\u2197 View response step")))),
                        react_1["default"].createElement(button_1["default"], { themed: true, variant: "warning", onClick: function () { return removeConfigItem('parameters', index); } }, "Remove parameter"))); }),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                            return addConfigItem('parameters', {
                                name: 'new_parameter',
                                type: 'string',
                                description: '',
                                required: false,
                            });
                        } }, "Add parameter"))),
                selected.type === 'condition' && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                    react_1["default"].createElement("label", null,
                        "Match",
                        react_1["default"].createElement("select", { value: ((_1 = selected.config) === null || _1 === void 0 ? void 0 : _1.match) || 'all', onChange: function (event) {
                                return updateSelected({
                                    config: __assign(__assign({}, selected.config), { match: event.target.value }),
                                });
                            } },
                            react_1["default"].createElement("option", { value: "all" }, "All conditions"),
                            react_1["default"].createElement("option", { value: "any" }, "Any condition"))),
                    (((_2 = selected.config) === null || _2 === void 0 ? void 0 : _2.conditions) || []).map(function (condition, index) {
                        var _a;
                        return (react_1["default"].createElement("div", { key: index, style: editorCardStyle },
                            react_1["default"].createElement(text_2["default"], { themed: true, label: "Parameter", value: condition.parameter || '', error: Boolean(parameterNameError(condition.parameter)), onChange: function (value) {
                                    return updateConfigItem('conditions', index, {
                                        parameter: value.trim(),
                                    });
                                } }),
                            parameterNameError(condition.parameter) && (react_1["default"].createElement(FieldError, null, PARAMETER_NAME_HINT)),
                            react_1["default"].createElement("label", null,
                                "Operator",
                                react_1["default"].createElement("select", { value: condition.operator || 'equals', onChange: function (event) {
                                        return updateConfigItem('conditions', index, {
                                            operator: event.target.value,
                                        });
                                    } },
                                    react_1["default"].createElement("option", { value: "equals" }, "Equals"),
                                    react_1["default"].createElement("option", { value: "not_equals" }, "Does not equal"),
                                    react_1["default"].createElement("option", { value: "contains" }, "Contains"),
                                    react_1["default"].createElement("option", { value: "not_contains" }, "Does not contain"),
                                    react_1["default"].createElement("option", { value: "greater_than" }, "Greater than"),
                                    react_1["default"].createElement("option", { value: "greater_than_or_equal" }, "Greater than or equal"),
                                    react_1["default"].createElement("option", { value: "less_than" }, "Less than"),
                                    react_1["default"].createElement("option", { value: "less_than_or_equal" }, "Less than or equal"),
                                    react_1["default"].createElement("option", { value: "exists" }, "Exists"),
                                    react_1["default"].createElement("option", { value: "not_exists" }, "Does not exist"))),
                            !['exists', 'not_exists'].includes(condition.operator) && (react_1["default"].createElement(text_2["default"], { themed: true, label: "Value", value: String((_a = condition.value) !== null && _a !== void 0 ? _a : ''), onChange: function (value) {
                                    return updateConfigItem('conditions', index, { value: value });
                                } })),
                            react_1["default"].createElement(button_1["default"], { themed: true, variant: "warning", onClick: function () { return removeConfigItem('conditions', index); } }, "Remove condition")));
                    }),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                            return addConfigItem('conditions', {
                                parameter: '',
                                operator: 'equals',
                                value: '',
                            });
                        } }, "Add condition"))),
                ['tool_execution', 'fallback_node'].includes(selected.type) && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                    react_1["default"].createElement("label", null,
                        "Tool source",
                        react_1["default"].createElement("select", { style: { display: 'block', width: '100%', marginTop: 6 }, value: selected.tool_source || 'common', onChange: function (event) {
                                return updateSelected(withHandoffRoutesCleared({
                                    tool_source: event.target.value,
                                    tool_id: null,
                                    tool_definition: event.target.value === 'agent_specific'
                                        ? {
                                            name: selected.node_name,
                                            description: '',
                                            mode: isFallbackNode
                                                ? 'handoff'
                                                : 'tool_call',
                                            parameters: VoiceAgentLayoutUtils_1.DEFAULT_TOOL_PARAMETERS,
                                            code: '',
                                        }
                                        : null,
                                }, isFallbackNode ? 'handoff' : undefined));
                            } },
                            react_1["default"].createElement("option", { value: "common" }, "Common tool"),
                            react_1["default"].createElement("option", { value: "agent_specific" }, "Agent-specific tool"))),
                    selected.tool_source !== 'agent_specific' ? (react_1["default"].createElement("label", { style: { display: 'block', marginTop: 12 } },
                        "Common tool",
                        react_1["default"].createElement("select", { style: {
                                display: 'block',
                                width: '100%',
                                marginTop: 6,
                            }, value: selected.tool_id || '', onChange: function (event) {
                                var picked = tools.find(function (tool) {
                                    return tool._common &&
                                        String(tool.id) === event.target.value;
                                });
                                updateSelected(withHandoffRoutesCleared({
                                    tool_id: Number(event.target.value) || null,
                                    tool_definition: null,
                                }, picked === null || picked === void 0 ? void 0 : picked.mode));
                            } },
                            react_1["default"].createElement("option", { value: "" }, "Select a common tool"),
                            tools
                                .filter(function (tool) {
                                return tool._common &&
                                    (!isFallbackNode || tool.mode === 'handoff');
                            })
                                .map(function (tool) { return (react_1["default"].createElement("option", { key: tool.id, value: tool.id },
                                tool.name,
                                " \u00B7 ",
                                tool.mode)); })))) : (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement("label", { style: { display: 'block', marginTop: 12 } },
                            "Agent-specific tool",
                            react_1["default"].createElement("select", { value: selected.tool_id || '', onChange: function (event) {
                                    var tool = tools.find(function (item) {
                                        return !item._common &&
                                            String(item.id) === event.target.value;
                                    });
                                    updateSelected(withHandoffRoutesCleared({
                                        tool_id: (tool === null || tool === void 0 ? void 0 : tool.id) || null,
                                        tool_definition: tool
                                            ? __assign(__assign({ name: tool.name || '', description: tool.description || '', mode: tool.mode || 'tool_call', parameters: tool.parameters ||
                                                    VoiceAgentLayoutUtils_1.DEFAULT_TOOL_PARAMETERS, code: tool.code || '', lambda_function_name: tool.lambda_function_name || '', app_id: tool.app_id || '' }, (tool.rag_project_number
                                                ? {
                                                    rag_project_number: tool.rag_project_number,
                                                }
                                                : {})), { prompt: tool.prompt || '', language_specific_prompt: tool.language_specific_prompt || {}, target_agent: tool.target_agent || '', requires_ack: Boolean(tool.requires_ack) }) : {
                                            name: selected.node_name,
                                            description: '',
                                            mode: 'tool_call',
                                            parameters: VoiceAgentLayoutUtils_1.DEFAULT_TOOL_PARAMETERS,
                                            code: '',
                                        },
                                    }, tool === null || tool === void 0 ? void 0 : tool.mode));
                                } },
                                react_1["default"].createElement("option", { value: "" }, "Create a new tool"),
                                tools
                                    .filter(function (tool) { return !tool._common; })
                                    .map(function (tool) { return (react_1["default"].createElement("option", { key: tool.id, value: tool.id }, tool.name)); }))),
                        react_1["default"].createElement(text_2["default"], { themed: true, label: "Tool name", value: ((_3 = selected.tool_definition) === null || _3 === void 0 ? void 0 : _3.name) || '', onChange: function (value) {
                                return updateToolDefinition({ name: value });
                            } }),
                        react_1["default"].createElement("label", { style: { display: 'block', marginTop: 12 } },
                            "Tool type",
                            react_1["default"].createElement("select", { style: {
                                    display: 'block',
                                    width: '100%',
                                    marginTop: 6,
                                }, value: selectedBehaviourId, onChange: function (event) {
                                    var behaviour = VoiceAgentLayoutUtils_1.toolBehaviorOptions.find(function (option) { return option.id === event.target.value; });
                                    var mode = (behaviour === null || behaviour === void 0 ? void 0 : behaviour.mode) || (behaviour === null || behaviour === void 0 ? void 0 : behaviour.id);
                                    if (mode !== 'tool_call') {
                                        updateToolDefinition({ mode: mode });
                                        return;
                                    }
                                    // Match the agents page: switching behaviour seeds
                                    // the matching template and drops the code-executor
                                    // function the previous choice was bound to.
                                    setCodeTypeDraft(function (current) {
                                        var _a;
                                        return (__assign(__assign({}, current), (_a = {}, _a[String(selected.id)] = (behaviour === null || behaviour === void 0 ? void 0 : behaviour.codeType) || 'advanced', _a)));
                                    });
                                    updateToolDefinition({
                                        mode: mode,
                                        lambda_function_name: '',
                                        parameters: VoiceAgentLayoutUtils_1.DEFAULT_TOOL_PARAMETERS,
                                        code: codeTemplateFor((behaviour === null || behaviour === void 0 ? void 0 : behaviour.codeType) || 'advanced'),
                                    });
                                } }, VoiceAgentLayoutUtils_1.toolBehaviorOptions
                                .filter(function (option) {
                                return !isFallbackNode || option.id === 'handoff';
                            })
                                .map(function (option) { return (react_1["default"].createElement("option", { key: option.id, value: option.id }, option.name)); }))),
                        ((_4 = selected.tool_definition) === null || _4 === void 0 ? void 0 : _4.mode) !== 'handoff' && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Tool parameters"),
                            Object.entries(((_6 = (_5 = selected.tool_definition) === null || _5 === void 0 ? void 0 : _5.parameters) === null || _6 === void 0 ? void 0 : _6.properties) ||
                                {}).map(function (_a, parameterIndex) {
                                var _b, _c, _d;
                                var name = _a[0], definition = _a[1];
                                return (react_1["default"].createElement("div", { key: parameterIndex, style: editorCardStyle },
                                    react_1["default"].createElement(text_2["default"], { themed: true, label: "Name", value: name, error: Boolean(parameterNameError(name)), onChange: function (value) {
                                            var _a, _b, _c;
                                            return updateToolParameter(name, value.trim(), definition, (_c = (_b = (_a = selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.required) === null || _c === void 0 ? void 0 : _c.includes(name));
                                        } }),
                                    parameterNameError(name) && (react_1["default"].createElement(FieldError, null, PARAMETER_NAME_HINT)),
                                    react_1["default"].createElement("label", null,
                                        "Type",
                                        react_1["default"].createElement("select", { value: definition.type || 'string', onChange: function (event) {
                                                var _a, _b, _c;
                                                return updateToolParameter(name, name, { type: event.target.value }, (_c = (_b = (_a = selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.required) === null || _c === void 0 ? void 0 : _c.includes(name));
                                            } }, VoiceAgentLayoutUtils_1.PARAMETER_TYPE_OPTIONS.map(function (option) { return (react_1["default"].createElement("option", { key: option.id, value: option.id }, option.name)); }))),
                                    react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "Description", value: definition.description || '', onChange: function (value) {
                                            var _a, _b, _c;
                                            return updateToolParameter(name, name, { description: value }, (_c = (_b = (_a = selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.required) === null || _c === void 0 ? void 0 : _c.includes(name));
                                        } }),
                                    react_1["default"].createElement("label", null,
                                        react_1["default"].createElement("input", { type: "checkbox", checked: Boolean((_d = (_c = (_b = selected.tool_definition) === null || _b === void 0 ? void 0 : _b.parameters) === null || _c === void 0 ? void 0 : _c.required) === null || _d === void 0 ? void 0 : _d.includes(name)), onChange: function (event) {
                                                return updateToolParameter(name, name, definition, event.target.checked);
                                            } }),
                                        ' ',
                                        "Required"),
                                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "warning", onClick: function () { return removeToolParameter(name); } }, "Remove parameter")));
                            }),
                            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () {
                                    var _a, _b;
                                    var count = Object.keys(((_b = (_a = selected.tool_definition) === null || _a === void 0 ? void 0 : _a.parameters) === null || _b === void 0 ? void 0 : _b.properties) || {}).length;
                                    updateToolParameter("parameter_" + (count + 1), "parameter_" + (count + 1), { type: 'string', description: '' }, false);
                                } }, "Add parameter"),
                            react_1["default"].createElement("details", { style: { marginTop: 10 } },
                                react_1["default"].createElement("summary", null, "Advanced JSON Schema"),
                                react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, value: toolParameters, onChange: setToolParameters }),
                                react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: applyToolParameters }, "Apply JSON")))),
                        ((_7 = selected.tool_definition) === null || _7 === void 0 ? void 0 : _7.mode) === 'rag' && (react_1["default"].createElement(react_1["default"].Fragment, null,
                            react_1["default"].createElement(text_2["default"], { themed: true, label: "RAG App ID", value: ((_8 = selected.tool_definition) === null || _8 === void 0 ? void 0 : _8.app_id) || '', onChange: function (value) {
                                    return updateToolDefinition({ app_id: value });
                                } }),
                            react_1["default"].createElement(text_2["default"], { themed: true, label: "RAG Project Number", placeholder: "Leave empty to use the default project", value: ((_9 = selected.tool_definition) === null || _9 === void 0 ? void 0 : _9.rag_project_number) || '', onChange: function (value) {
                                    return updateToolDefinition({
                                        rag_project_number: value.trim(),
                                    });
                                } }),
                            react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "RAG prompt", value: ((_10 = selected.tool_definition) === null || _10 === void 0 ? void 0 : _10.prompt) || '', onChange: function (value) {
                                    return updateToolDefinition({ prompt: value });
                                } }),
                            (function () {
                                var _a;
                                // Extra instruction per language, added to the RAG
                                // prompt for calls in that language: the same
                                // language_specific_prompt the agents page edits.
                                var languagePrompts = ((_a = selected.tool_definition) === null || _a === void 0 ? void 0 : _a.language_specific_prompt) || {};
                                var activeCode = availableLanguages.some(function (language) { return language.code === ragPromptLanguage; })
                                    ? ragPromptLanguage
                                    : defaultLanguageCode;
                                var languageOptions = availableLanguages.map(function (language) { return ({
                                    id: language.code,
                                    name: language.name,
                                }); });
                                var configuredCount = Object.values(languagePrompts).filter(function (text) { return String(text || '').trim(); })
                                    .length;
                                return (react_1["default"].createElement(react_1["default"].Fragment, null,
                                    react_1["default"].createElement("div", { style: { marginTop: 12 } },
                                        react_1["default"].createElement(dropdown_1["default"], { themed: true, optionKey: "name", label: "Language", placeholder: "Select language", options: languageOptions, value: languageOptions.find(function (option) { return option.id === activeCode; }) || {}, onChange: function (option) { var _a; return setRagPromptLanguage((_a = option === null || option === void 0 ? void 0 : option.id) !== null && _a !== void 0 ? _a : ''); } })),
                                    react_1["default"].createElement(text_2["default"], { themed: true, multiline: true, label: "Language-specific RAG prompt (" + languageNameFor(activeCode) + ")", placeholder: "Add RAG prompt instruction for the selected language", value: languagePrompts[activeCode] || '', onChange: function (value) {
                                            var next = __assign({}, languagePrompts);
                                            // An emptied instruction is dropped rather
                                            // than saved as a blank entry.
                                            if (value.trim())
                                                next[activeCode] = value;
                                            else
                                                delete next[activeCode];
                                            updateToolDefinition({
                                                language_specific_prompt: next,
                                            });
                                        } }),
                                    react_1["default"].createElement("span", { style: { color: '#667085', fontSize: 11 } },
                                        configuredCount,
                                        " language",
                                        configuredCount === 1 ? '' : 's',
                                        " configured")));
                            })())),
                        ((_11 = selected.tool_definition) === null || _11 === void 0 ? void 0 : _11.mode) === 'handoff' && (react_1["default"].createElement("label", { style: { display: 'block', marginTop: 12 } },
                            "Handoff agent",
                            react_1["default"].createElement("select", { style: {
                                    display: 'block',
                                    width: '100%',
                                    marginTop: 6,
                                }, value: ((_12 = selected.tool_definition) === null || _12 === void 0 ? void 0 : _12.target_agent) || '', onChange: function (event) {
                                    return updateToolDefinition({
                                        target_agent: event.target.value,
                                    });
                                } },
                                react_1["default"].createElement("option", { value: "" }, "Select an agent"),
                                agents
                                    .filter(function (agent) {
                                    return String(agent.id || agent.db_id) !==
                                        String(agentId);
                                })
                                    .map(function (agent) { return (react_1["default"].createElement("option", { key: agent.id || agent.db_id, value: agent.name }, agent.name)); })))),
                        ((_13 = selected.tool_definition) === null || _13 === void 0 ? void 0 : _13.mode) === 'tool_call' && (react_1["default"].createElement("div", { style: { marginTop: 14 } },
                            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () { return setCodeEditorNodeId(selected.id); } }, "Edit code"),
                            react_1["default"].createElement(text_1["default"], { variant: "body.sm", color: "grey.dark" }, "Code is stored directly on this workflow step."),
                            ((_14 = selected.tool_definition) === null || _14 === void 0 ? void 0 : _14.lambda_function_name) && (react_1["default"].createElement("a", { href: const_2.BASE_URL + "code_executor/logs/" + selected.tool_definition.lambda_function_name + "/", target: "_blank", rel: "noopener noreferrer", style: {
                                    display: 'inline-block',
                                    marginTop: 6,
                                    color: '#146ef5',
                                    fontSize: 12,
                                    fontWeight: 600,
                                } }, "View Logs \u2197")))))),
                    isFaqHandoff && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(StepPicker, { label: "FAQ return step", emptyLabel: "Resume where the caller left off", withId: true, value: (_15 = selected.config) === null || _15 === void 0 ? void 0 : _15.faq_return_node_id, steps: nodes.filter(function (node) {
                                return String(node.id) !== String(selected.id) &&
                                    !node._draft;
                            }), onChange: function (nodeId) {
                                return updateSelected({
                                    config: __assign(__assign({}, selected.config), { faq_return_node_id: Number(nodeId) || null }),
                                });
                            } }),
                        react_1["default"].createElement("span", { style: { color: '#667085', fontSize: 11 } }, "The FAQ agent answers one question and the workflow resumes. Pick a step to always return there, or leave it to come back to the last step that asked the caller something."))),
                    react_1["default"].createElement("div", { style: __assign(__assign({}, editorCardStyle), { marginTop: 14 }) },
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Processing Message"),
                        [
                            ['nothing', 'Nothing'],
                            ['default', 'Platform Default'],
                            ['custom', 'Custom Response'],
                        ].map(function (_a) {
                            var _b, _c;
                            var value = _a[0], label = _a[1];
                            return (react_1["default"].createElement("label", { key: value },
                                react_1["default"].createElement("input", { type: "radio", name: "ack-" + selected.id, checked: (((_c = (_b = selected.config) === null || _b === void 0 ? void 0 : _b.acknowledgement_config) === null || _c === void 0 ? void 0 : _c.type) ||
                                        'nothing') === value, onChange: function () {
                                        return updateSelected({
                                            config: __assign(__assign({}, selected.config), { acknowledgement_config: {
                                                    type: value,
                                                    response_node_id: null,
                                                } }),
                                        });
                                    } }),
                                ' ',
                                label));
                        }),
                        ((_17 = (_16 = selected.config) === null || _16 === void 0 ? void 0 : _16.acknowledgement_config) === null || _17 === void 0 ? void 0 : _17.type) ===
                            'custom' &&
                            (responseSteps.length ? (react_1["default"].createElement(react_1["default"].Fragment, null,
                                react_1["default"].createElement(StepPicker, { label: "Bot Response step", emptyLabel: "Select Bot Response step", value: (_19 = (_18 = selected.config) === null || _18 === void 0 ? void 0 : _18.acknowledgement_config) === null || _19 === void 0 ? void 0 : _19.response_node_id, steps: responseSteps.map(function (node) {
                                        return node._draft
                                            ? __assign(__assign({}, node), { node_name: node.node_name + " (unsaved)" }) : node;
                                    }), onChange: function (nodeId) {
                                        var draft = responseSteps.find(function (node) {
                                            return node._draft && String(node.id) === nodeId;
                                        });
                                        if (draft) {
                                            pickDraftAcknowledgement(selected, draft);
                                            return;
                                        }
                                        updateSelected({
                                            config: __assign(__assign({}, selected.config), { acknowledgement_config: {
                                                    type: 'custom',
                                                    response_node_id: Number(nodeId) || null,
                                                } }),
                                        });
                                    } }),
                                !((_21 = (_20 = selected.config) === null || _20 === void 0 ? void 0 : _20.acknowledgement_config) === null || _21 === void 0 ? void 0 : _21.response_node_id) && (react_1["default"].createElement(FieldError, null, CUSTOM_ACK_MISSING)))) : (react_1["default"].createElement("div", { style: { marginTop: 10 } },
                                react_1["default"].createElement(FieldError, null, "There is no Bot Response step yet. Create one, write the message and save it, then choose it here."),
                                react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", onClick: function () { return addNode('bot_response'); } }, "Create Bot Response step"))))))),
                (selected.type === 'bot_response'
                    ? []
                    : routeKeys(selected)).map(function (route) {
                    var _a;
                    return (react_1["default"].createElement(StepPicker, { key: route.key, label: route.label, emptyLabel: "No next step", value: (_a = destinationFor(selected, route.key)) === null || _a === void 0 ? void 0 : _a.target_node_id, steps: nodes.filter(function (node) {
                            return String(node.id) !== String(selected.id) && !node._draft;
                        }), onChange: function (nodeId) { return updateRoute(route.key, nodeId); } }));
                }),
                react_1["default"].createElement("div", { className: "workflow-editor-actions", style: { display: 'flex', gap: 8, marginTop: 18 } },
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", disabled: saving ||
                            Boolean(duplicateNameNode) ||
                            audioRegenerationInProgress ||
                            !selectedHasUnsavedChanges, title: audioRegenerationInProgress
                            ? 'Response audio is being regenerated for the previous voice change. Wait for it to finish before saving.'
                            : !selectedHasUnsavedChanges
                                ? 'No changes to save on this step.'
                                : undefined, onClick: function () { return saveNode(); } }, saving ? 'Saving…' : 'Save step'),
                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "warning", disabled: saving, onClick: removeNode }, "Delete"))))),
            react_1["default"].createElement("div", { style: {
                    position: 'absolute',
                    top: 12,
                    right: 16,
                    zIndex: 30,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 8,
                } },
                audioRegenerationFailed && (react_1["default"].createElement("div", { role: "alert", style: {
                        maxWidth: 320,
                        padding: '8px 12px',
                        border: '1px solid #fda29b',
                        borderRadius: 10,
                        background: '#fef3f2',
                        color: '#b42318',
                        boxShadow: '0 4px 12px #1018281a',
                        fontSize: 12,
                        fontWeight: 600,
                        lineHeight: 1.4,
                    } }, "Last bulk audio update for node responses failed. Please regenerate the audio.")),
                react_1["default"].createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: 5,
                        border: '1px solid #d8dee8',
                        borderRadius: 10,
                        background: '#fff',
                        boxShadow: '0 4px 12px #1018281a',
                    } },
                    react_1["default"].createElement("button", { type: "button", "aria-label": "Zoom out", onClick: function () { return zoomTo(zoom - 0.1); } }, "\u2212"),
                    react_1["default"].createElement("span", { style: { minWidth: 44, textAlign: 'center' } },
                        Math.round(zoom * 100),
                        "%"),
                    react_1["default"].createElement("button", { type: "button", "aria-label": "Zoom in", onClick: function () { return zoomTo(zoom + 0.1); } }, "+"))),
            edgeMenu && (react_1["default"].createElement("div", { className: "workflow-connection-menu", style: {
                    position: 'fixed',
                    left: edgeMenu.x,
                    top: edgeMenu.y,
                    zIndex: 1100,
                    minWidth: 190,
                    padding: 6,
                    border: '1px solid #d8dee8',
                    borderRadius: 10,
                    background: '#fff',
                    boxShadow: '0 10px 28px #10182830',
                }, onClick: function (event) { return event.stopPropagation(); } },
                react_1["default"].createElement("div", { style: {
                        padding: '6px 9px 8px',
                        color: '#667085',
                        fontSize: 11,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '.04em',
                    } }, "Connection navigation"),
                react_1["default"].createElement("button", { type: "button", style: { display: 'block', width: '100%', padding: '9px 10px' }, onClick: function () {
                        var source = nodes.find(function (node) { return String(node.id) === String(edgeMenu.sourceId); });
                        if (source)
                            focusNode(source);
                        setEdgeMenu(null);
                    } },
                    react_1["default"].createElement("strong", null, "\u2190 Source"),
                    react_1["default"].createElement("span", { style: { display: 'block', color: '#667085', fontSize: 11 } }, ((_22 = nodes.find(function (node) { return String(node.id) === String(edgeMenu.sourceId); })) === null || _22 === void 0 ? void 0 : _22.node_name) || 'Source step')),
                react_1["default"].createElement("button", { type: "button", style: { display: 'block', width: '100%', padding: '9px 10px' }, onClick: function () {
                        var target = nodes.find(function (node) { return String(node.id) === String(edgeMenu.targetId); });
                        if (target)
                            focusNode(target);
                        setEdgeMenu(null);
                    } },
                    react_1["default"].createElement("strong", null, "Destination \u2192"),
                    react_1["default"].createElement("span", { style: { display: 'block', color: '#667085', fontSize: 11 } }, ((_23 = nodes.find(function (node) { return String(node.id) === String(edgeMenu.targetId); })) === null || _23 === void 0 ? void 0 : _23.node_name) || 'Destination step')),
                Boolean(edgePointFor(nodes.find(function (node) { return String(node.id) === String(edgeMenu.sourceId); }) || {}, edgeMenu.key)) && (react_1["default"].createElement("button", { type: "button", style: {
                        display: 'block',
                        width: '100%',
                        padding: '9px 10px',
                        borderTop: '1px solid #f0f2f6',
                    }, onClick: function () {
                        var source = nodes.find(function (node) { return String(node.id) === String(edgeMenu.sourceId); });
                        if (source)
                            saveEdgePoint(source, edgeMenu.key, null);
                        setEdgeMenu(null);
                    } }, "Reset connection shape")),
                react_1["default"].createElement("button", { type: "button", style: {
                        display: 'block',
                        width: '100%',
                        padding: '9px 10px',
                        color: '#b42318',
                        borderTop: '1px solid #f0f2f6',
                    }, onClick: function () {
                        var source = nodes.find(function (node) { return String(node.id) === String(edgeMenu.sourceId); });
                        if (source)
                            confirmDeleteConnection(source, edgeMenu.key);
                        setEdgeMenu(null);
                    } }, "Delete connection"))),
            nodeMenu && (react_1["default"].createElement("div", { className: "workflow-connection-menu", style: {
                    position: 'fixed',
                    left: nodeMenu.x,
                    top: nodeMenu.y,
                    zIndex: 1100,
                    minWidth: 230,
                    padding: 6,
                    border: '1px solid #d8dee8',
                    borderRadius: 10,
                    background: '#fff',
                    boxShadow: '0 10px 28px #10182830',
                }, onClick: function (event) { return event.stopPropagation(); } },
                react_1["default"].createElement("div", { style: {
                        padding: '6px 9px',
                        color: '#667085',
                        fontSize: 11,
                        fontWeight: 700,
                    } }, nodeMenu.title),
                nodeMenu.items.map(function (item, index) { return (react_1["default"].createElement("button", { key: item.label + "-" + index, type: "button", style: {
                        display: 'block',
                        width: '100%',
                        padding: 9,
                        border: 0,
                        borderRadius: 6,
                        background: '#fff',
                        textAlign: 'left',
                    }, onClick: function () {
                        focusNode(item.node);
                        setNodeMenu(null);
                    } }, item.label)); }))),
            selected &&
                String(codeEditorNodeId) === String(selected.id) &&
                ['tool_execution', 'fallback_node'].includes(selected.type) &&
                selected.tool_source === 'agent_specific' &&
                ((_24 = selected.tool_definition) === null || _24 === void 0 ? void 0 : _24.mode) === 'tool_call' && (react_1["default"].createElement(CodeEditor_1["default"], { id: String(selected.id), code: ((_25 = selected.tool_definition) === null || _25 === void 0 ? void 0 : _25.code) ||
                    codeTemplateFor(selectedCodeType), inputJSON: JSON.stringify({ abc: '123' }, null, 2), envVariables: envVariables, envVariablesEnabled: canEditEnvVariables, isVoiceAgent: [3, 4].includes(botSettings === null || botSettings === void 0 ? void 0 : botSettings.domain_type), onRun: function (inputJSON, callback) {
                    return runToolCode(inputJSON, callback);
                }, onSaveWithVariables: function (variables, code, callback) { return saveToolCodeWithVariables(variables, code, callback); }, onSave: function (code, callback) { return __awaiter(void 0, void 0, void 0, function () {
                    var definition, deploysFunction, lambdaFunctionName, payload, response, body, error_9, updated, _a, saved, nodeId;
                    var _b, _c, _d;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                definition = selected.tool_definition || {};
                                deploysFunction = (definition.mode || 'tool_call') === 'tool_call' &&
                                    selectedCodeType === 'advanced';
                                lambdaFunctionName = definition.lambda_function_name || '';
                                if (!deploysFunction) return [3 /*break*/, 4];
                                _e.label = 1;
                            case 1:
                                _e.trys.push([1, 3, , 4]);
                                payload = {
                                    custom_code_block: code,
                                };
                                // Reuse the existing function so a re-save updates it in
                                // place rather than leaving an orphan behind.
                                if (lambdaFunctionName.trim()) {
                                    payload.function_name = lambdaFunctionName;
                                }
                                return [4 /*yield*/, api_1.createCodeExecutorFunction(payload)];
                            case 2:
                                response = _e.sent();
                                if (!(response === null || response === void 0 ? void 0 : response.success)) {
                                    throw new Error(((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.error) || 'Failed to save code.');
                                }
                                body = VoiceAgentLayoutUtils_1.getResponseBody(response === null || response === void 0 ? void 0 : response.response);
                                lambdaFunctionName = (_d = (_c = body === null || body === void 0 ? void 0 : body['lambda_function_name']) !== null && _c !== void 0 ? _c : body === null || body === void 0 ? void 0 : body['function_name']) !== null && _d !== void 0 ? _d : lambdaFunctionName;
                                return [3 /*break*/, 4];
                            case 3:
                                error_9 = _e.sent();
                                notifyFailed((error_9 === null || error_9 === void 0 ? void 0 : error_9.message) || 'Could not save the code for this step.');
                                callback(false);
                                return [2 /*return*/];
                            case 4:
                                updated = __assign(__assign({}, selected), { tool_source: 'agent_specific', tool_definition: __assign(__assign(__assign({}, definition), { code: code }), (lambdaFunctionName
                                        ? { lambda_function_name: lambdaFunctionName }
                                        : {})) });
                                updateSelected({
                                    tool_source: 'agent_specific',
                                    tool_definition: updated.tool_definition,
                                });
                                return [4 /*yield*/, saveNode(updated)];
                            case 5:
                                _a = _e.sent(), saved = _a.saved, nodeId = _a.nodeId;
                                // A draft node is re-keyed to its server id on save; follow it
                                // so the editor stays open on the node it was opened for.
                                if (saved && nodeId !== null)
                                    setCodeEditorNodeId(nodeId);
                                callback(saved);
                                return [2 /*return*/];
                        }
                    });
                }); }, navToMenu: function () { return setCodeEditorNodeId(null); } })))));
};
exports["default"] = WorkflowAgentBuilder;
